<template>
  <svg
    width="1875"
    height="1055"
    viewBox="0 0 1875 1055"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1521_20473)">
      <g clip-path="url(#clip1_1521_20473)">
        <path
          d="M1632.27 768.779L1631.68 764.521L1630.13 758.756L1628.43 754.094L1625.69 748.227L1622.34 742.886L1619.46 738.942L1617.32 736.342L1611.77 730.507L1599.82 718.314L1594.62 712.973L1594.75 713.169L1569.42 687.427L1542.5 660.133L1537.57 655.135L1516.25 633.474L1495.22 612.11L1486.27 603.155L1481.58 598.461V598.46L1477.68 594.621L1477.72 594.597L1437.46 554.294L1341.84 459.507L1332.99 450.53L1311.5 429.351L1302.69 420.606L1297.48 415.657L1292.27 411.391L1285.46 406.376L1275.66 399.933L1266.79 394.731L1257.33 389.811L1249.53 386.221L1242.31 383.28L1234.53 380.558L1227.9 378.46L1219.21 376.063L1214.87 375.043L1208.3 373.614L1203.09 372.811L1199.49 372.437L1193.45 372.294L1186.63 372.532L1181.13 373.068L1172.82 374.24L1168.36 375.047L1164.31 375.976L1160.67 377.029L1156.47 378.503L1153 379.91L1149.31 381.599L1145.15 383.731L1141.69 385.705L1140.38 386.567L1138.1 388.054L1129.84 393.949L1125.47 396.85L1121.02 399.858L1118.83 400.82L1117.54 401.254L1116.19 401.538L1114.79 401.653L1113.01 401.604L1111.6 401.414L1110.57 401.178L1109.62 400.837L1108.72 400.389L1107.37 399.465L1104.2 397.154L1098.28 393.087L1091.55 388.017L1090.62 387.352L1090.47 387.324L1087.35 385.826L1084.1 385.079H1080.64L1078.98 385.21L1075.64 386.79L1070.93 389.297L1064.04 393.306L1061.13 394.797L1055.45 398.217L1051.6 400.656L1048.95 402.334L1039.87 408.753L1029.55 416.541L981.405 452.923L980.45 453.644L958.771 470.078L955.717 472.412L954.872 472.933L946.01 479.099L931.193 488.232L921.355 493.437L907.864 499.259L886.718 507.027L877.541 509.89L858.914 514.682L853.897 515.598L851.135 515.944L848.784 516.09L843.106 516.204L837.472 516.029L835.093 515.822L831.259 515.308L825.652 514.237L810.74 509.903L812.368 516.504L823.272 519.672L830.239 521.026L834.152 521.554L836.971 521.803L843.061 521.985L849.14 521.861L851.927 521.688L855.179 521.286L860.723 520.269L879.83 515.357L889.386 512.376L907.914 505.565L913.845 503.205L924.889 498.443L928.747 496.401L936.686 491.875L955.667 480.331L963.543 474.312L975.54 465.179L981.405 460.706L985.401 457.66L1027.84 425.332L1039.93 419.054L1043.41 416.087L1045.92 414.22L1050.3 411.343L1051.86 410.342L1061.42 404.229L1062.63 403.454L1067.24 401.044L1070.01 399.779L1076.25 393.338L1081.57 390.875L1082.23 390.642L1082.56 390.566L1082.9 390.522L1083.25 390.524L1083.95 390.63L1084.61 390.837L1085.52 391.263L1086.88 392.177L1101.67 403.029V403.03L1103.47 404.355L1105.19 405.369L1106.42 405.911L1108.4 406.505L1111.15 407.037L1113.93 407.309L1116.05 407.329L1117.8 407.17L1119.16 406.893L1121.44 406.14L1123.63 405.218L1125.69 404.129L1128.16 402.509L1134.26 398.119L1140.34 393.996L1143.73 391.692L1147.13 389.649L1151.26 387.442L1155.2 385.563L1158.67 384.155L1161.9 383.048L1166.83 381.549L1170.61 381.393L1176.48 381.412L1183.27 381.61L1194.56 381.438L1195.43 382.739L1200.05 383.268L1203.28 383.797L1207.3 384.572L1210.14 385.336L1210.25 385.354L1214.31 386.887L1220.43 389.933L1221 390.067L1224.75 391.059L1228.84 392.402L1232.29 393.655L1235.57 395.044L1239.49 396.716L1246.17 399.787L1254.57 404.251L1265.03 409.715L1272.97 414.964L1277.44 418.465L1289.11 429.15L1289.65 429.709L1347.29 489.687L1347.21 490.744L1346.6 491.718L1345.65 492.76L1456.3 603.188L1457.46 603.378L1458.69 603.69L1459.88 604.355L1460.29 604.635L1461.4 605.49L1465.45 609.509L1470.16 614.183L1474.93 618.916L1477.8 621.409L1498 637.87L1499.93 636.093L1516.25 650.443L1527.26 660.133L1532.35 664.605L1543.46 674.211L1546.33 676.769L1552.32 682.559L1565.52 695.597L1595.08 725.079L1606.19 736.144L1610.93 740.794L1615.58 745.753L1617.64 748.537L1620.45 752.556L1622.31 756.772L1624 761.192L1624.93 765.613L1625.57 769.137L1625.91 772.798L1625.77 775.779L1625.28 780.085L1624.38 784.706L1622.64 790.45L1614.67 810.5L1612.67 814.659L1610.61 817.344L1608.58 819.425L1608.13 819.869L1606.3 821.452L1604.45 822.825L1602.51 824.134L1600.11 825.557L1599.91 825.679L1598.78 826.315L1596.22 827.523L1595.4 827.855L1592.84 828.837L1590 829.675L1588.08 830.06L1585.99 830.392L1583.54 830.709L1581.39 830.914L1578.96 830.96L1576.22 830.834L1573.11 830.496L1572.19 830.382L1571.06 830.199L1569.95 829.99L1568.85 829.755L1567.89 829.53L1566.94 829.283L1566.01 829.019L1565.22 828.807L1564.45 828.579L1563.68 828.333L1562.9 828.04L1562.13 827.724L1560.48 827.011L1559.58 826.619L1558.7 826.206L1557.89 825.781L1557.14 825.36L1556.3 824.877L1555.33 824.277L1554.39 823.655L1553.46 823.003L1552.25 822.043L1551.06 821.038L1549.89 820.032L1548.05 818.145L1544.38 813.932L1539.69 808.182L1532.1 798.77L1516.95 779.793L1516.25 778.906L1488.01 743.178L1485.08 739.656L1482.01 735.896L1479.41 733.053L1476.74 730.636L1473.79 728.558L1469.73 726.21L1465.52 724.036L1461.58 722.445L1458.14 721.331L1453.81 720.202L1449.81 719.514L1445.37 718.974L1441.81 718.807L1437.35 718.702L1432.8 718.814L1423.95 718.855L1419.79 718.709L1415.16 718.458L1412.17 717.948L1408.69 717.302L1405.04 716.343L1401.8 715.183L1398.46 713.776L1395.4 712.369L1392.65 710.693L1390.42 709.155L1388.52 707.761L1386.63 706.214L1384.78 704.361L1382.67 702.074L1379.96 697.957L1378.41 694.829L1376.66 690.589L1370.66 672.913L1369.69 670.417L1367 663.236L1365.97 660.133L1364.97 657.104L1363.18 651.811L1361.93 648.793L1360.69 646.407L1359.09 643.833L1356.35 639.798L1354.62 637.628L1352.66 635.577L1350.33 633.411L1347.64 631.122L1344.82 628.953L1341.56 626.77L1338.68 625.092L1335.72 623.559L1332.62 622.192L1329.41 621.022L1324.46 619.548L1320.4 618.593L1317.31 618.061L1312.79 617.55L1298.46 616.723L1285.39 616.387L1283.36 616.362L1278.1 616.222L1274.26 615.957L1270.43 615.522L1266.63 614.94L1262.55 614.089L1259.55 613.272L1256.62 612.3L1253.44 611.055L1249.46 609.227L1246.5 607.665L1243.67 605.953L1240.98 604.102L1237.41 601.312L1234.78 598.974L1232.35 596.508L1230.12 593.909L1227.93 590.932L1226.04 587.838L1224.29 584.36L1223.25 581.893L1222.41 579.387L1221.85 576.828L1221.61 574.238L1221.61 571.625L1221.91 567.862L1222.38 564.991L1223.16 562.178L1224.18 559.413L1233.53 538.65L1239.23 525.538L1242.57 517.189L1243.56 511.955L1243.98 505.267L1243.12 498.477L1241.37 491.405L1239.42 486.816L1236.59 481.873L1231.89 475.851L1226.73 470.936L1221.67 467.076L1215.38 463.308L1208.05 460.043L1197.89 455.628L1183.59 449.876L1182.66 449.433L1174.64 446.758L1167.43 444.69L1159.82 443.019L1158.42 442.863L1154.99 442.27L1149.5 441.371L1142.89 440.55L1140.04 440.296L1135.9 439.925L1130.66 439.601L1125.04 439.438L1116.27 439.462L1111.71 439.702L1108.56 439.636L1099.46 439.861L1084.57 442.055L1072.72 446.237L1070.31 447.4L1067.21 448.735L1063.67 449.991L1057.82 451.982L1053.39 453.732L1046.57 456.726L1038.99 460.346L1034.88 462.554L1030.65 465.208L1021.15 471.175L1011.08 479.326L1003.44 486.917L987.325 503.046L981.405 508.91L963.119 527.032L955.313 534.807L936.977 553.065L936.372 553.675L935.618 554.226L934.154 554.811L932.584 555.213L930.463 555.529L834.434 562.74L832.687 562.773L831.011 562.661L829.398 562.497L828.113 562.278L827.064 562.002L826.203 561.6L825.623 561.17L824.911 560.34L823.898 558.803L823.101 557.267L821.279 552.456L813.023 519.148L812.406 516.656L812.368 516.503L803.906 514.044L803.954 514.241L804.532 516.677L812.883 551.72L814.513 556.9L815.52 559.57L816.628 561.708L818.04 563.837L819.545 565.619L821.487 567.036L823.796 568.115L826.059 568.721L828.092 569.065L830.196 569.277L832.462 569.425L834.898 569.379L931.299 562.146L933.736 561.758L935.282 561.41L936.64 560.908L938.049 560.174L939.345 559.348L940.662 558.464L955.255 543.941L968.528 530.719L981.405 517.727L998.245 500.736L1008.14 490.793L1013.4 485.752L1017.2 482.346L1020.92 479.277L1024.54 476.541L1029.67 473.036L1034.45 470.092L1039.08 467.47L1043.52 465.136L1049.87 462.065L1055.76 459.494L1063.05 456.619L1072.66 453.093L1076.6 451.768L1079.48 450.793L1084.12 449.433L1088.16 448.462L1091.92 447.749L1098.14 446.864L1103.03 446.371L1108.27 446.036L1117.06 445.722L1129.77 445.402L1137.75 445.945L1140 446.187L1144.73 446.698L1149.72 447.432L1157.93 448.868L1164.83 450.418L1172.77 452.581L1180.31 455.03L1189.54 458.598L1197.82 462.086L1200.5 463.196L1207.66 466.261L1212.52 468.59L1215.14 470.036L1217.9 471.823L1220.24 473.58L1222.69 475.661L1224.98 477.85L1227.3 480.392L1229.01 482.58L1231.22 485.873L1232.74 488.482L1234.17 491.434L1235.26 494.481L1236.15 497.878L1236.84 501.604L1237.12 504.491L1237.14 507.377L1236.87 510.55L1236.35 513.999L1235.76 516.255L1234.84 518.744L1223.85 543.406L1223.37 544.478L1219.81 552.786L1217.46 558.234L1216.35 561.282L1215.51 564.389L1214.97 567.542L1214.75 570.138L1214.77 573.606L1215.05 577.081L1215.53 579.952L1216.04 581.926L1217.09 584.681L1218.9 588.447L1220.96 592.122L1223.36 595.659L1225.47 598.321L1227.76 600.881L1230.45 603.548L1233.35 606.068L1236.44 608.423L1240 610.781L1243.73 612.943L1247.64 614.874L1251.69 616.602L1255.87 618.107L1259.17 619.097L1262.52 619.951L1265.93 620.666L1269.37 621.207L1274.6 621.688L1285.87 622.263L1307.08 622.842L1310.94 623.015L1314.78 623.391L1318.57 624.009L1322.29 624.882L1325.25 625.785L1329.09 627.212L1332.79 628.875L1336.34 630.753L1339.71 632.832L1342.1 634.531L1344.61 636.566L1346.9 638.75L1349.03 641.053L1350.98 643.468L1352.72 645.979L1354.22 648.593L1355.48 651.293L1356.97 655.155L1358.52 660.133L1359.43 662.994L1363.44 674.973L1370.12 694.774L1372.3 699.507L1374.86 703.451L1378.74 708.173L1383.33 712.309L1388.28 715.686L1391.15 717.351L1394.69 719.211L1398.47 720.851L1402.18 722.165L1406.48 723.176L1411.05 724.163L1413.84 724.575L1416.78 724.848L1422.46 725.029L1430.26 725.052L1439.79 724.972L1445.05 725.123L1448.45 725.486L1452.78 726.383L1456.38 727.267L1460.93 728.962L1465.23 731.126L1468.54 733.095L1471.38 735.206L1475.67 738.846L1479.59 742.916L1483.25 747.4L1510.54 782.152L1516.25 789.412L1533.41 811.276L1541.75 821.517L1543.46 823.478L1545.28 825.308L1545.43 825.435L1547.6 827.224L1550.25 829.266L1553.13 831.025L1556.52 832.66L1561.33 834.577L1564.02 835.434L1567.92 836.329L1571.86 836.953L1575.07 837.258L1578.31 837.393L1581.56 837.333L1584.66 837.092L1587.74 836.677L1590.78 836.097L1593.51 835.419L1596.18 834.611L1598.79 833.658L1600.98 832.719L1603.12 831.669L1605.18 830.54L1607.16 829.336L1609.08 828.043L1610.87 826.651L1612.03 825.611L1612.3 825.376L1613.63 824.022L1614.91 822.629L1616.12 821.195L1617.28 819.715L1618.33 818.199L1619.42 816.313L1621.33 812.43L1628.41 794.915L1629.53 790.521L1630.95 785.966L1631.53 783.598L1631.95 780.94L1632.28 778.375L1632.53 773.67L1632.27 768.779L1632.27 768.779ZM1495.11 627.057L1483.68 616.932L1478.13 611.454L1476.7 610.052L1471.74 605.173V605.172L1462.38 595.961L1354.38 488.643L1327.52 460.022L1295.72 428.689L1283.65 418.092L1279.94 415.04L1265.87 406.123L1256.01 400.627L1249.31 397.147L1247.41 396.214L1243.62 394.347L1238.64 392.018L1234.73 390.416L1231.52 389.257L1229.5 388.573L1228.41 388.224L1227.32 387.874L1217.32 384.349L1214.35 383.463L1209.28 382.297L1209.2 382.281C1209.14 382.266 1209.03 382.241 1208.87 382.207L1205.67 381.491C1205.55 381.465 1205.45 381.442 1205.35 381.42L1204.74 381.284L1205.69 381.153L1209.54 381.014L1212 381.118L1214.08 381.359L1216.1 381.691L1219.46 382.48L1225.44 384.287L1234.55 387.525L1242.68 390.821L1249.65 394.044L1256.07 397.391L1268.45 406.968L1277.06 412.445L1283.27 416.846L1309.63 439.726L1338.88 468.704L1365.76 495.457L1416.36 545.787L1454.15 583.262L1474.57 603.539L1479.08 608.006L1495.11 627.056L1495.11 627.053L1495.11 627.057V627.057Z"
          fill="white"
          fill-opacity="0.2"
        />
        <path
          d="M1516.25 650.444L1499.93 636.093L1498 637.871L1477.8 621.409L1474.93 618.917L1470.16 614.184L1465.45 609.509L1461.4 605.49L1460.29 604.635L1459.88 604.355L1458.69 603.691L1457.46 603.379L1456.31 603.188L1345.65 492.761L1346.6 491.719L1347.21 490.744L1347.29 489.687L1289.11 429.151L1277.44 418.465L1272.97 414.964L1265.03 409.715L1254.57 404.252L1246.17 399.787L1239.49 396.716L1235.57 395.045L1232.3 393.656L1228.84 392.403L1224.75 391.06L1221 390.068L1218.26 389.42L1215.18 388.788L1213.27 388.449L1210.81 388.184L1208.31 388.108L1205.42 388.211L1202.22 388.54L1197.02 389.222L1191.35 390.399L1187.03 391.762L1184.97 392.515L1182.98 393.501L1180.13 395.211L1176.39 397.924L1174.21 399.816L1172.69 401.405L1170.76 403.818L1170.39 404.764L1173.69 408.064L1174.22 408.454L1174.52 408.587L1174.84 408.653L1175.56 408.663L1176.96 405.892L1178.58 402.611L1179.92 400.639L1180.26 400.149L1182.11 397.666L1183.65 395.978L1184.17 395.488L1185.29 394.616L1186.97 393.57L1188.99 392.534L1191.86 391.569L1196.74 390.265L1197.34 392.9L1196.28 392.733"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M810.74 509.903L802.344 507.462L803.906 514.044L812.368 516.504L810.74 509.903Z"
          fill="white"
          fill-opacity="0.2"
        />
        <path
          d="M810.741 509.903L810.706 509.76L810.089 507.261L793.663 441L783.187 397.027L782.66 392.821L782.462 389.75L782.484 387.525L782.542 385.086L783.034 381.435L783.571 378.813L784.248 376.18L785.16 373.044L786.395 369.824L788.329 365.744L795.55 351.67L803.551 336.448L810.509 324.984L812.689 320.965L813.423 318.187L813.848 315.299L813.306 312.313L812.091 309.341L810.311 306.571L807.325 303.828L803.955 301.779L800.777 300.552L797.463 299.727L793.829 299.503L789.734 299.966L786.235 300.776L782.765 302.096L779.863 303.953L777.299 306.252L775.072 308.89L755.987 338.779L748.006 348.948L727.56 374.464L725.307 376.627L711.048 387.406L709.292 389.699L701.637 397.301L700.647 398.241L697.577 401.025L695.299 402.819L693.395 404.089L691.332 405.201L689.742 405.86L678.893 411.062L672.621 412.93L668.594 413.936L663.147 415.057L656.628 416.226L652.131 416.878L646.913 417.392L643.297 417.665L619.271 419.4L615.767 419.518L611.207 419.424L601.944 419.272L591.78 418.598L580.369 417.295L567.127 414.977L557.449 413.044L543.89 409.604L507.367 398.727L494.729 394.059L486.38 390.323L475.196 384.396L464.422 377.977L456.212 372.34L446.856 364.692L446.563 364.426L439.731 358.221L438.763 357.217L438.762 357.216L435.064 353.871L430.193 348.327L425.603 342.731L420.957 336.027L416.425 329.145L403.228 304.396L396.835 292.088L393.808 286.012L392.274 282.975L372.983 246.465L372.426 245.588L369.876 242.444L366.25 238.897L363.296 236.658L359.283 234.05L355.527 232.08L351.494 230.462L346.508 229.025L340.547 227.963L334.01 227.409L323.288 227.265L312.497 227.733L306.408 228.366L296.911 229.696L286.496 231.802L277.976 234.066L271.232 236.373L268.732 237.472L264.853 239.403L260.731 242.034L257.126 245.064L255.352 246.937L253.981 248.376L251.448 251.706L249.581 255.103L247.754 258.692L246.515 262.611L245.887 266.372L245.75 270.337L246.258 274.484L247.303 279.016L248.918 283.359L251.127 287.954L253.634 292.393L255.053 294.376L256.889 296.957L260.813 301.337L266.197 306.593L270.169 310.05L276.739 315.362L281.169 318.439L302.934 332.627L316.702 341.672L331.468 350.684L348.774 360.749L366.664 370.486L382.796 378.713L398.315 386.341L412.295 392.709L424.93 398.082L438.466 403.794V403.795H438.467L443.373 405.869L446.562 407.29H446.563L451.61 409.54L459.963 413.636L470.454 415.9L563.249 444.069L597.198 455.523L618.61 461.404L641.622 466.868L789.606 509.885V509.886L803.907 514.043L802.345 507.461L810.741 509.903V509.903ZM792.021 504.46L792.022 504.459L625.423 456.028L565.586 438.614L501.092 419.831L487.7 415.57L455.418 404.463L446.563 400.722H446.562L438.508 397.32H438.507L428.141 392.939L415.606 387.608L401.805 381.326L386.442 373.773L370.444 365.618L352.735 355.974L335.583 346.001L320.985 337.089L307.293 328.103L285.521 313.909L277.961 307.626L272.377 302.891L268.406 299.052L265.515 295.831L264.547 294.746L261.553 290.663L259.034 286.276L257.171 282.337L255.269 277.946L255.16 277.346L254.475 273.699L254.153 270.182L254.333 267.224L255.035 263.723L255.251 262.996L255.998 260.381L258.223 255.782L260.555 252.306L263.067 249.062L265.846 246.686L269.884 244.219L274.623 241.787L280.524 239.765L288.509 237.649L298.411 235.639L307.487 234.371L313.189 233.783L323.636 233.233L328.942 233.279L336.639 233.619L342.178 234.44L347.447 235.769L352.04 237.604L356.622 240.041L360.254 242.699L363.017 245.122L365.714 248.186L368.578 252.632L368.918 253.263L385.783 285.173L387.185 287.827L402.281 316.394L406.5 324.245L411.427 332.824L416.797 341.396L423.186 349.808L428.203 355.558L434.381 361.96L438.707 365.894H438.708L441.784 368.687L446.562 372.598H446.563L451.481 376.622L460.112 382.543L471.235 389.172L482.803 395.304L491.615 399.243L506.13 404.607L521.927 409.936L541.281 415.9L555.308 419.458L565.339 421.462L578.974 423.85L590.903 425.215L601.559 425.92L617.018 426.126L633.298 425.149L652.442 423.348L660.983 422.147L671.301 419.885L680.567 416.988L691.593 411.794L700.976 406.359L706.993 402.518L715.964 395.711L722.952 389.446L737.289 373.097L753.887 352.095L764.14 339.044L784.674 313.118L787.95 310.068L789.886 309.084L792.311 308.538L795.106 308.395L797.509 308.891L798.545 309.272L800.73 310.322L802.154 311.368L803.672 313.017L804.718 315.46L804.865 317.543L804.352 319.929L803.169 322.624L789.101 349.393L781.825 363.566L779.774 367.898L778.391 371.493L777.399 374.906L776.672 377.735L776.078 380.635L775.533 384.71L775.467 387.444L775.443 389.882L775.661 393.278L776.242 397.881L801.718 504.824L802.308 507.306H802.307L802.345 507.461L800.504 506.926L792.021 504.46V504.46Z"
          fill="white"
          fill-opacity="0.2"
        />
        <path
          d="M344.279 364.522L345.854 363.25L347.723 364.826L346.159 366.097L344.279 364.522V364.522Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M428.395 279.113L431.886 278.318L432.935 281.452L429.441 282.245L428.395 279.113V279.113Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M223.86 278.204L224.814 280.388L223.183 280.924L222.236 278.742L223.86 278.204Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M288.311 211.401L290.644 210.578L291.477 212.178L289.141 213.001L288.311 211.401H288.311Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M357.928 207.649L358.708 206.241L360.591 206.948L359.817 208.356L357.928 207.649V207.649Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M439.229 283.497L438.685 281.92L437.434 282.21L436.904 280.664L439.251 280.112"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M439.262 278.639L436.32 270.106L435.581 270.275L435.016 268.644L439.332 267.632"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M439.378 260.077H439.372L438.396 257.841L439.395 257.51"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M432.638 272.979L435.097 280.246L433.403 280.637L430.943 273.371L432.638 272.979Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M262.436 356.4L264.621 357.151L263.583 359.21L261.398 358.466L262.436 356.4V356.4Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M439.332 267.632L446.562 265.939"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M439.395 257.51L440.436 257.197L441.01 258.478L446.562 256.796"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M442.541 386.648L441.211 386.025L441.926 384.986L443.255 385.606L442.541 386.648V386.648Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M446.564 311.521L445.562 308.625L446.564 308.392"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M446.562 304.272L445.744 304.464L442.567 295.247L443.234 295.092L439.23 283.497"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M439.252 280.113L439.73 280L439.261 278.639"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M439.332 267.632V267.632"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M446.562 260.87L445.486 261.196L445.581 261.41L444.837 261.638L444.822 261.609L442.059 262.446L441.956 262.215L441.554 262.336L441.742 262.746L441.018 262.963L439.688 259.986L439.379 260.077"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M554.693 719.555L555.757 718.763L557.154 720.035L556.088 720.827L554.693 719.555V719.555Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M637.887 699.821L639.416 698.92L640.341 699.994L638.814 700.889L637.887 699.821V699.821Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M507.199 476.774L510.517 470.509L514.403 471.786L511.085 478.051L507.199 476.774Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M537.647 474.882L536.262 474.211L536.686 473.617L538.071 474.289L537.647 474.882Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M816.795 373.159L820.089 370.712L825.894 376.008L822.601 378.457L816.795 373.159V373.159Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M560.18 573.343L560.406 572.169L562.685 572.468L562.46 573.643L560.18 573.343V573.343Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M767.68 518.992L768.654 519.4L768.151 520.207L767.178 519.799L767.68 518.992Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M758.078 522.586L754.695 521.311L755.214 520.377L758.596 521.657L758.078 522.586V522.586Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M915.623 585.74L916.842 584.831L917.862 585.75L916.634 586.664L915.623 585.74Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M885.772 539.643L887.862 539.785L887.713 541.286L885.623 541.146L885.772 539.643V539.643Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M790.857 493.256L791.765 490.803L793.453 491.227L792.555 493.68L790.857 493.256Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M682.123 524.869L683.564 524.567L683.838 525.455L682.391 525.759L682.123 524.869V524.869Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M681.919 525.948L679.404 526.401L679.068 525.122L681.582 524.669L681.919 525.948V525.948Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M718.681 514.725L718.544 516.355L716.615 516.243L716.745 514.618L718.681 514.725V514.725Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M691.899 484.282L688.277 483.333L688.762 482.064L692.392 483.012L691.899 484.282V484.282Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M696.916 474.411L697.394 473.176L698.81 473.551L698.325 474.781L696.916 474.411Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M706.605 513.441L706.814 509.413L712.77 509.618L712.569 513.641L706.605 513.441V513.441Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M683.057 523.711L686.429 518.72L690.06 520.389L686.681 525.38L683.057 523.711V523.711Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M701.082 515.447L701.621 510.385L706.237 510.717L705.698 515.779L701.082 515.447Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M701.953 519.573L702.607 516.176L705.741 516.59L705.088 519.98L701.953 519.573V519.573Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M734.576 516.773L735.151 514.89L741.136 516.13L740.705 517.545L737.651 516.907L737.505 517.38L734.576 516.773V516.773Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M732.514 513.456L732.998 511.511L734.869 511.824L734.379 513.771L732.514 513.456V513.456Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M743.564 516.308L744.677 513.52L755.416 516.429L754.304 519.211L743.564 516.308V516.308Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M666.518 539.843L670.317 537.253L673.232 540.15L669.432 542.749L666.518 539.843V539.843Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M625.584 644.163L625.741 642.463L627.187 642.55L627.035 644.256L625.584 644.163V644.163Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M630.24 634.615L630.325 633.499L632.477 633.613L632.394 634.724L630.24 634.615H630.24Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M465.312 264.398L464.49 262.187L466.078 261.788L466.9 264.001L465.312 264.398V264.398Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M474.477 264.797L473.494 263.491L474.473 262.992L475.448 264.298L474.477 264.797V264.797Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M477.41 298.785L483.081 297.521L480.922 303.761L474.96 305.325L473.314 300.536L477.468 299.565L477.41 298.785V298.785Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M477.953 406.289L478.233 405.526L479.269 405.787L478.999 406.547L477.953 406.289V406.289Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M511.806 448.83L510.223 448.384L510.466 447.802L512.049 448.253L511.806 448.83V448.83Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M471.197 427.189L469.943 426.548L470.665 425.586L471.926 426.232L471.197 427.189V427.189Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M597.088 432.266L595.334 432.189L595.405 431.072L597.165 431.15L597.088 432.266V432.266Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M461.613 319.604L473.036 316.913L473.676 318.755L462.255 321.444L461.613 319.604V319.604Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M490.752 434.495L492.274 431.199L498.474 433.239L497.876 434.489L496.321 433.987L495.396 436.034L490.752 434.495V434.495Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M479.373 431.45L480.113 428.974L483.071 429.568L482.33 432.052L479.373 431.45V431.45Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M523.227 468.131L525.922 468.126L525.936 470.363H523.234L523.227 468.131V468.131Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M474.412 429.127L475.643 427.572L478.504 429.111L477.272 430.666L474.412 429.127V429.127Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M457.578 278.712L460.334 278.009L460.941 279.612L458.186 280.317L457.578 278.712H457.578Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M771.872 399.563L771.57 398.405L773.152 398.123L773.453 399.28L771.872 399.563Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M789.938 407.919L791.266 407.625L791.625 408.719L790.296 409.014L789.938 407.919V407.919Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M726.58 323.619L731.501 316.83L735.511 318.808L730.597 325.596L726.58 323.619Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M718.113 338.232L721.145 331.701L724.837 332.866L721.806 339.399L718.113 338.232V338.232Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M735.283 315.709L736.481 313.915L738.132 314.663L736.935 316.455L735.283 315.709V315.709Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M668.336 361.073L671.916 364.14L669.575 365.991L668.116 364.748L667.277 365.416L665.649 364.026L666.455 363.394L665.064 362.197L667.731 360.087L668.624 360.848L668.336 361.073V361.073Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M654.456 364.67L660.69 372.22L657.338 373.933L655.8 372.227L652.202 372.771L652.01 371.904L649.982 372.063L649.493 369.257L649.156 369.371L648.686 366.207L653.063 365.525L654.456 364.67V364.67Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M536.344 487.035L537.568 480.803L538.663 480.916L538.916 479.618L540.599 479.844L540.556 480.052L541.061 480.118L540.902 480.896L540.432 480.838L540.353 481.235L541.671 481.415L540.459 487.55L536.344 487.035V487.035Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M654.307 355.397L659.773 343.668L664.401 347.446L660.709 355.379L658.937 359.175L654.307 355.397H654.307Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M658.936 359.174L660.708 355.378L665.739 359.748L662.593 362.296L658.936 359.174Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M503.781 486.767L504.867 484.701L507.529 485.649L506.442 487.721L503.781 486.767V486.767Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M486.402 526.74L493.576 526.613L493.72 532.4L486.556 532.526L486.402 526.74V526.74Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M622.021 572.072L665.561 541.204L667.8 543.347L624.261 574.21L622.021 572.072V572.072Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M446.562 265.939L447.624 265.691L448.81 269.142L451.797 268.444L464.029 303.895L466.362 303.35L466.846 304.74L468.278 304.405L470.616 311.167L448.251 316.406L446.562 311.52"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M446.562 308.392L449.864 307.62L448.548 303.805L446.562 304.271"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M446.562 256.795L447.865 256.401L448.302 257.374L448.816 257.221L449.314 258.345L448.807 258.493L449.478 259.987L446.562 260.869"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M945.596 512.975L944.036 514.315L942.975 513.479L944.534 512.139L945.596 512.975V512.975Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M844.761 591.674L843.072 590.123L844.286 589.221L845.981 590.772L844.761 591.674V591.674Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M796.024 563.013L797.196 564.03L795.772 565.139L794.6 564.122L796.024 563.013V563.013Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M805.656 287.212L808.228 287.934L807.885 288.765L805.314 288.043L805.656 287.212V287.212Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M806.742 480.762L806.061 478.863L807.41 478.533L808.093 480.433L806.742 480.762V480.762Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M719.244 344.493L716.963 347.957L715.549 347.321L717.824 343.862L719.244 344.493V344.493Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M686.505 423.56L684.366 424.533L683.727 423.577L685.859 422.604L686.505 423.56V423.56Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M694.464 419.241L692.422 420.238L691.754 419.31L693.789 418.312L694.464 419.241V419.241Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M691.663 515.655L691.159 517.687L689.42 517.396L689.925 515.358L691.663 515.655V515.655Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M699.365 516.445L698.831 518.692L697.514 518.478L698.047 516.231L699.365 516.445V516.445Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M712.346 514.479L716.079 514.674L715.994 515.76L712.262 515.564L712.346 514.479Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M676.395 537.211L673.231 539.319L671.467 537.519L674.638 535.416L676.395 537.211V537.211Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M512.021 449.225L513.52 449.641L513.207 450.403L511.707 449.986L512.021 449.225Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M489.359 357.995L492.579 362.502L490.953 363.286L487.732 358.78L489.359 357.995Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M492.939 367.498L493.794 368.675L492.795 369.168L491.939 367.991L492.939 367.498Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M469.287 270.445L474.284 269.374L474.971 271.556L469.975 272.628L469.287 270.445Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M482.74 297.24L470.257 300.031L467.627 292.047L480.109 289.257L482.74 297.24Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M452.283 245.997L454.109 251.335L450.363 252.204L448.537 246.865L452.283 245.997Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M461.227 264.623L459.218 265.013L458.936 264.017L460.946 263.633L461.227 264.623Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M539.613 492.548L540.159 504.904L535.302 505.051L534.756 492.694L539.613 492.548V492.548Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M642.008 548.063L644.948 545.908L647.258 548.046L644.318 550.201L642.008 548.063V548.063Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M502.266 486.651L508.449 488.759L505.905 493.825L499.721 491.717L502.266 486.651V486.651Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1317.75 683.016L1323.31 687.739L1320.43 690.047L1314.86 685.321L1317.75 683.016V683.016Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1321.19 692.459L1323.75 689.95L1325.17 690.938L1324.88 691.221L1327.99 693.373L1326.88 694.462L1323.72 692.274L1322.57 693.412L1321.19 692.459V692.459Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1328.53 697.538L1325.78 695.492L1326.9 694.474L1329.65 696.522L1328.53 697.538Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1498.06 686.093L1496.39 684.935L1497.55 683.795L1499.22 684.948L1498.06 686.093V686.093Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1511.93 859.182L1510.5 858.049L1511.31 857.358L1512.74 858.493L1511.93 859.182Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1464.54 829.205L1467.65 826.627L1476.97 834.238L1473.88 836.813L1464.54 829.205V829.205Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1475.14 837.616L1478.12 835.167L1484.13 840.119L1482.12 841.781L1477.99 838.375L1477.02 839.163L1475.14 837.616V837.616Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1462.66 827.102L1464.53 825.37L1466.25 826.639L1464.38 828.365L1462.66 827.102Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1489.18 714.174L1497.75 702.72L1502.6 705.179L1494.03 716.636L1489.18 714.174Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1501.07 698.149L1505.21 692.547L1511.18 695.551L1510.93 695.904L1511.71 696.294L1511.06 697.157L1510.27 696.762L1507.03 701.141L1501.07 698.149V698.149Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1435.45 806.962L1437.85 804.902L1441.01 807.401L1441.57 806.913L1444.7 809.389L1443.88 810.091L1448.09 813.423L1445.93 815.268L1435.45 806.962V806.962Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1504.24 706.574L1507.15 702.373L1514.35 705.763L1511.44 709.966L1504.24 706.574Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1445.53 816.737L1447.01 815.562L1449.77 817.923L1448.3 819.096L1445.53 816.737V816.737Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1501.91 701.106L1502.65 700.191L1506.19 702.159L1505.43 703.075L1501.91 701.106Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1503.29 689.85L1504.13 688.692L1505.84 689.521L1505 690.686L1503.29 689.85Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1481.91 725.172L1482.85 723.997L1484.41 724.843L1483.47 726.016L1481.91 725.172V725.172Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1461.55 825.346L1458.51 822.842L1459.94 821.662L1462.98 824.167L1461.55 825.346Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1292.86 708.822L1284.2 703.767L1285.78 701.951L1294.43 707.003L1292.86 708.822V708.822Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1254.64 660.133L1254.15 660.592L1253.52 660.133"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1516.25 862.706L1512.46 859.838L1513.83 858.607L1515.04 859.531L1516.11 858.577L1516.25 858.682"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1478.07 707.678L1493.31 687.431L1503.67 692.727L1488.43 712.974L1478.07 707.678Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1429.17 795.498L1431.34 797.907L1430.21 798.602L1428.03 796.193L1429.17 795.498Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1431.88 798.238L1434.13 800.428L1432.81 801.353L1430.55 799.163L1431.88 798.238V798.238Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1414.22 693.052L1416.39 693.755L1415.71 695.191L1413.54 694.487L1414.22 693.052V693.052Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1392.87 660.79L1391.98 661.972L1390.81 661.377L1391.7 660.195L1392.87 660.79Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1454.68 817.73L1456.84 819.549L1455.33 820.762L1453.17 818.943L1454.68 817.73V817.73Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1454.37 822.284L1457.28 824.276L1456.26 825.288L1453.35 823.298L1454.37 822.284V822.284Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1451.15 819.016L1453.79 821.253L1452.69 822.133L1450.05 819.902L1451.15 819.016V819.016Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1425.48 790.729L1426.05 791.674L1425.12 792.058L1424.55 791.113L1425.48 790.729Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1427.43 792.467L1429.06 794.642L1427.58 795.393L1425.95 793.218L1427.43 792.467V792.467Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M993.104 476.391L990.756 474.732L992.163 473.375L994.516 475.032L993.104 476.391V476.391Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1105.64 466.329L1112.17 473.972L1109.36 475.567L1106.88 472.665L1103.2 467.751L1105.64 466.328V466.329V466.329Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M988.918 474.662L987.598 473.83L988.489 472.868L989.81 473.705L988.918 474.662Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1001.93 532.122L1003.96 530.523L1006.41 532.632L1004.37 534.23L1001.93 532.122V532.122Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1395.76 654.24L1397.8 651.295L1399.2 651.955L1397.16 654.901L1395.76 654.24Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1112.61 474.291L1116.38 478.627L1113.49 480.306L1109.74 475.995L1112.61 474.291V474.291Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1119.41 496.921L1118.82 491.656L1122.62 491.366L1123.21 496.63L1119.41 496.921V496.921Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1299.82 568.669L1285.78 566.734L1286.86 561.426L1300.9 563.362L1299.82 568.669V568.669Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1282.65 567.861L1272.75 570.963L1270.41 565.91L1280.34 562.809L1282.65 567.861V567.861Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1264.56 568.593L1267.17 566.889L1268.46 568.217L1265.85 569.924L1264.56 568.593V568.593Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1265.83 579.735L1293.83 583.594L1293.78 583.882L1294.96 584.044L1294.71 585.286L1293.78 585.159L1293.07 588.683L1264.81 584.795L1265.83 579.735V579.735Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1253.4 658.982L1254.79 659.987L1254.64 660.133"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1095.61 517.686L1096.28 515.208L1101.67 516.122L1101 518.502L1095.61 517.686V517.686Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1050.49 533.669L1048.31 531.85L1049.75 530.671L1051.94 532.484L1050.49 533.669V533.669Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1054.61 537.215L1051.05 534.4L1052.31 533.313L1055.88 536.128L1054.61 537.215V537.215Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1064.39 537.591L1062.32 535.873L1064.43 534.142L1066.51 535.862L1064.39 537.591V537.591Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1066.99 535.436L1064.88 533.669L1066.98 531.961L1069.1 533.728L1066.99 535.436Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1064.36 515.428L1067.36 517.834L1066.15 518.857L1063.15 516.445L1064.36 515.428Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1068.35 518.469L1071.35 521.024L1070.14 521.991L1067.13 519.429L1068.35 518.469V518.469Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1061.95 505.917L1052.35 497.84L1055.49 495.301L1058.56 492.826L1068.16 500.904L1065.22 503.278L1061.95 505.917V505.917Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1053.5 499.308L1059.37 504.143L1058.18 505.12L1052.32 500.285L1053.5 499.308Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1046.7 530.237L1045.33 529.057L1046.39 528.224L1047.75 529.402L1046.7 530.237V530.237Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1006.37 527.972L1016.49 519.801L1028.98 530.302L1018.85 538.474L1006.37 527.972Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1027.58 523.678L1032.09 519.974L1036.68 523.775L1032.18 527.479L1027.58 523.678V523.678Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1501.32 564.845L1501.45 563.221L1502.56 563.277L1502.44 564.902L1501.32 564.845Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1504.56 565.11L1504.71 563.382L1505.56 563.436L1505.4 565.164L1504.56 565.11V565.11Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1502.02 567.936L1500.35 567.79L1500.51 566.518L1502.19 566.664L1502.02 567.936Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1439.88 501.215L1437.35 498.632L1438.49 497.891L1441 500.469L1439.88 501.215V501.215Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1477.99 628.156L1479.25 629.375L1478.25 630.082L1476.99 628.856L1477.99 628.156Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1487.68 569.422L1487.98 565.428L1493.49 565.706L1493.18 569.7L1487.68 569.422V569.422Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1499.03 570.044L1499.24 568.444L1503.2 568.796L1502.98 570.404L1499.03 570.044V570.044Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1447.9 626.333L1449.62 625.965L1450.45 628.572L1448.72 628.945L1447.9 626.333V626.333Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1461.37 621.614L1463.73 620.056L1464.76 621.12L1462.4 622.671L1461.37 621.614V621.614Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1440.3 629.613L1442.61 629.115L1443.04 630.487L1440.73 630.98L1440.3 629.613Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1433.35 631.178L1435.07 630.78L1435.51 632.084L1433.79 632.474L1433.35 631.178Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1417.3 624.678L1403.05 609.844L1408.16 606.513L1422.41 621.349L1417.3 624.678V624.678Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1425.32 631.431L1426.91 631.028L1427.79 633.373L1426.19 633.776L1425.32 631.431V631.431Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1397.66 404.094L1398.69 400.376L1404.02 401.377L1403 405.096L1397.66 404.094V404.094Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1397.33 386.807L1400.81 385.543L1401.87 387.544L1398.39 388.8L1397.33 386.807V386.807Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1117.45 455.568L1116.52 454.617L1117.6 453.905L1118.53 454.863L1117.45 455.568Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1102.5 417.249L1104.92 416.81L1105.33 418.355L1102.92 418.789L1102.5 417.249Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1298.53 408.176L1299.81 407.273L1300.8 408.232L1299.51 409.134L1298.53 408.176Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1225.11 333.088L1223.57 333.052L1223.6 332.081L1225.14 332.117L1225.11 333.088V333.088Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1182.84 427.731L1184.59 428.45L1183.84 429.685L1182.09 428.971L1182.84 427.731V427.731Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1372.29 424.226L1373.49 423.475L1376.59 426.807L1375.39 427.559L1372.29 424.226Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1375.57 424.601L1376.91 423.86L1377.79 424.957L1376.45 425.696L1375.57 424.601V424.601Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1299.31 384.313L1303.87 380.34L1314.73 388.792L1310.16 392.769L1299.31 384.313V384.313Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1359.73 373.898L1363.45 371.729L1363.91 372.245L1364.66 371.809L1369.81 377.821L1370.09 377.655L1371.04 378.764L1366.26 381.528L1359.73 373.898V373.898Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1281.94 347.225L1287.03 342.293L1287.37 342.526L1290.03 339.948L1292.56 341.717L1289.85 344.347L1290.5 344.801L1288.7 346.545L1288.15 346.165L1284.92 349.315L1281.94 347.225V347.225Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1306.54 374.894L1307.22 373.868L1310.14 375.164L1309.48 376.196L1306.54 374.894Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1222 336.166L1222.2 333.22L1231.17 333.634L1230.97 336.583L1222 336.166V336.166Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1234.1 323.862L1236.04 321.603L1237.75 322.599L1235.81 324.862L1234.1 323.862V323.862Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1220.27 320.192L1221.26 319.259L1222.53 320.178L1221.54 321.109L1220.27 320.192V320.192Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1191 352.663L1192.28 351.997L1192.98 352.914L1191.71 353.579L1191 352.663V352.663Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1380.77 395.15L1385.43 392.263L1390.31 397.591L1385.64 400.478L1380.77 395.15Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1377.49 423.747L1378.77 422.852L1379.5 423.566L1378.23 424.456L1377.49 423.747Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1068.92 382.581L1070.2 384.097L1068.2 385.239L1066.93 383.717L1068.92 382.581V382.581Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1385.12 372.01L1389.89 370.249L1395.46 380.484L1390.69 382.239L1385.12 372.01V372.01Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1389.96 399.527L1390.2 398.412L1393.5 398.883L1393.25 400.004L1389.96 399.527V399.527Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1414.55 395.624L1415.3 393.921L1417.81 394.668L1417.05 396.369L1414.55 395.624Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1411.36 395.551L1412.61 392.989L1413.88 393.411L1412.62 395.973L1411.36 395.551Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1413.11 415.655L1413.37 414.807L1416.79 415.503L1416.53 416.352L1413.11 415.655V415.655Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1460.77 551.964L1433.99 525.291L1447.9 515.819L1455.2 523.096L1455.36 522.992L1456.87 524.501L1456.64 524.664L1465.82 533.815L1466.15 533.598L1467.77 535.217L1467.16 535.63L1474.3 542.738L1460.77 551.964V551.964Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1481.35 635.538L1492.94 647.665L1488.18 650.731L1477.05 639.014L1477.78 638.55L1475.65 636.28L1480.37 633.232L1482.05 635.083L1481.35 635.538V635.538Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1056.16 510.662L1053.06 513.192L1049.93 515.752L1043.92 520.655L1034 512.415L1039.88 507.604L1046.15 502.481L1046.22 502.42L1056.16 510.662V510.662Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1058.23 532.506L1048.38 524.45L1051.38 521.96L1057.56 516.843L1060.51 514.397L1070.35 522.454L1070.17 522.601L1067.01 525.226L1064.33 527.445L1061.16 530.073L1058.23 532.506V532.506Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1285.57 341.096L1286.38 340.348L1286.98 340.779L1286.16 341.532L1285.57 341.096V341.096Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1288.91 340.81L1287.47 339.845L1288.25 339.073L1289.68 340.039L1288.91 340.81Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1061.16 530.073L1064.33 527.445L1065.05 528.038L1061.89 530.66L1061.16 530.073V530.073Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1061.95 505.916L1065.22 503.277L1066.01 503.941L1062.74 506.579L1061.95 505.916Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1057.55 516.843L1051.38 521.96L1050.52 521.251L1056.69 516.133L1057.55 516.843V516.843Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1049.93 515.752L1053.06 513.192L1053.79 513.803L1050.66 516.361L1049.93 515.752V515.752Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1055.49 495.301L1052.35 497.84L1051.21 496.882L1054.35 494.345L1055.49 495.301V495.301Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1046.15 502.481L1039.88 507.604L1037.95 505.996L1044.21 500.873L1046.15 502.481Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1067.01 525.226L1070.17 522.601L1070.93 523.219L1067.76 525.849L1067.01 525.226Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1073.07 478.447L1071.38 478.273L1071.58 476.897L1073.28 477.078L1073.07 478.447V478.447Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1461.59 511.157L1466.66 516.331L1466.38 516.948L1464.43 516.078L1462.76 515.041L1461.8 513.915L1461.07 512.583L1460.73 511.286L1461.59 511.157V511.157Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1215.46 364.85L1216.96 364.827L1216.99 365.954L1215.48 365.976L1215.46 364.85V364.85Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1372.54 383.158L1382.25 393.509L1379.84 395.042L1370.13 384.692L1372.54 383.158V383.158Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1370.44 380.258L1371.3 379.707L1371.87 380.304L1371 380.856L1370.44 380.259V380.258Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1253.52 660.133L1252.76 659.592L1253.4 658.982"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1253.35 490.816L1251.91 490.844L1251.87 489L1253.31 488.978L1253.35 490.816V490.816Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1347.88 614.993L1348.95 614.038L1350.32 615.102L1349.24 616.045L1347.88 614.993V614.993Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1293.1 348.072L1294.07 346.886L1295.04 347.428L1294.07 348.609L1293.1 348.072Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1510.39 517.364L1509.18 519.896L1508.15 519.568L1509.35 517.03L1510.39 517.364V517.364Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1250.47 657.737L1247.97 656.153L1248.63 655.445L1251.13 657.035L1250.47 657.737V657.737Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1516.25 603.874L1512.5 600.161L1515.39 598.18L1516.25 599.023"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1516.25 599.334L1515.75 599.673L1516.25 600.165"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1516.25 597.575L1514.41 597.637L1514.14 592.034L1516.25 591.967"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1516.25 590.728L1515.61 591.174L1514.8 590.39L1516.25 589.372"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1488.52 549.341L1489.62 551.953L1488.53 552.267L1487.42 549.654L1488.52 549.341V549.341Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1489.4 550.091L1491.95 549.235L1493.03 551.413L1490.47 552.275L1489.4 550.091Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1516.25 516.268L1509.83 514.083L1513.33 507.087L1511.95 506.617L1514.22 502.095L1515.55 502.545L1516.25 501.146"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1509.92 526.553L1508.01 525.973L1508.48 524.917L1510.39 525.497L1509.92 526.553Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1415.83 412.124L1415.22 413.989L1413.77 413.664L1414.38 411.805L1415.83 412.124V412.124Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1415.6 418.91L1411.69 431.796L1410.23 431.494L1414.15 418.614L1415.6 418.91Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1400.44 435.73L1408.07 433.226L1408.62 434.361L1400.99 436.865L1400.44 435.73Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1427.85 520.599L1344.47 437.788L1357.21 429.086L1379.37 451.095L1381.84 449.406L1383.22 450.765L1380.77 452.436L1440.61 511.879L1427.85 520.599V520.599Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1451.99 504.899L1455.65 508.564L1449.7 512.579L1446.06 508.909L1451.99 504.899V504.899Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1303.99 453.6L1455.69 604.179L1457.9 607.874L1457 609.302L1454.03 611.463L1451.51 612.724L1448.3 614.022L1445.54 614.82L1441.21 615.419L1438.99 615.513L1287.51 464.453L1288.19 462.179L1289.41 459.49L1291.36 456.671L1292.82 455.192L1295.53 452.788L1297.72 451.445L1299.37 450.804L1300.23 450.918L1303.99 453.6V453.6Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1346.32 424.661L1347.64 426.378L1346.09 427.192L1344.76 425.475L1346.32 424.661Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1344.97 423.712L1343.39 424.55L1342.92 423.946L1344.48 423.109L1344.97 423.712V423.712Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1293.18 493.535L1308.6 508.958L1302.94 512.796L1287.53 497.367L1293.18 493.535Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1310.24 510.526L1330.67 531.048L1325.18 534.759L1304.75 514.243L1310.24 510.526Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1332.42 532.936L1353.12 553.348L1347.47 557.243L1326.76 536.836L1332.42 532.936V532.936Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1382.69 582.466L1403.22 603.132L1397.7 606.854L1377.16 586.187L1382.69 582.466Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1395.32 657.077L1393.5 659.699L1392.48 659.215L1394.31 656.599L1395.32 657.077Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1239.99 654.673L1227.91 645.399L1230.03 643.523L1242.11 652.797L1239.99 654.673V654.673Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1264.84 569.642L1266.25 571.227L1265.2 571.857L1263.79 570.267L1264.84 569.642V569.642Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1263.49 571.312L1260.96 573.006L1260.13 572.159L1262.65 570.464L1263.49 571.312V571.312Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1260.26 573.264L1258.28 574.574L1257.7 573.97L1259.67 572.666L1260.26 573.264V573.264Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1252.18 453.405L1253.97 452.008L1255.14 453.037L1253.35 454.427L1252.18 453.405Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1274.56 430.438L1276.23 433.59L1273.82 434.458L1272.15 431.305L1274.56 430.438V430.438Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1271.62 432.817L1273.16 436.183L1270.64 436.964L1269.11 433.599L1271.62 432.817Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1270.4 431.17L1268.13 432.137L1267.32 430.838L1269.58 429.872L1270.4 431.17V431.17Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1267.02 427.958L1265.44 424.916L1266.76 424.454L1268.33 427.496L1267.02 427.958Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1227.97 315.166L1226.49 316.559L1225.81 316.07L1227.29 314.672L1227.97 315.166V315.166Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1225.9 316.985L1224.49 318.423L1223.88 318.017L1225.27 316.577L1225.9 316.985V316.985Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1191 343.754L1188.12 344.996L1187.45 343.946L1190.34 342.704L1191 343.754Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1187.44 345.19L1184.42 346.223L1183.83 345.047L1186.85 344.014L1187.44 345.19Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1151.41 529.917L1149.01 530.866L1148.36 529.754L1150.75 528.805L1151.41 529.917Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1097.31 550.524L1103.63 551.76L1102.79 554.682L1096.46 553.441L1097.31 550.524V550.524Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1373.19 422.642L1375.69 420.785L1377.11 422.092L1374.6 423.949L1373.19 422.642V422.642Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1368.52 613.182L1387.39 599.865L1401.29 613.236L1382.43 626.553L1368.52 613.182Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1339.07 376.031L1345.66 383.01L1340.66 386.26L1342.45 388.493L1340.71 389.822L1343 392.647L1341.21 393.495L1320.63 371.157L1321.9 370.122L1328.21 376.389L1330.78 375.07L1332.95 376.705L1334.86 375.573L1337.23 377.417L1339.07 376.031V376.031Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1346.76 572.138L1361.79 561.983L1367.33 567.558L1381.22 558.18L1384.14 561.111L1370.33 570.444L1375.7 575.834L1360.36 586.208L1358.8 587.003L1357.12 587.429L1355.75 587.562L1354.34 587.516L1352.74 587.299L1351.58 587.065L1349.64 586.507L1347.74 585.365L1346.15 583.969L1345 582.612L1344.26 580.892L1343.88 578.636L1344.01 577L1344.81 574.448L1345.78 573.152L1346.76 572.138V572.138Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1166.37 355.405L1139.34 359.599L1138.73 356.919L1137.2 357.155L1135.84 351.223L1137.67 350.936L1137.89 351.869L1164.05 347.803L1163.75 346.484L1165.83 346.164L1167.32 352.663L1165.8 352.899L1166.37 355.405V355.405Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1136.54 361.656L1109.61 365.423L1109.07 362.773L1106.28 363.501L1107.46 365.94L1081.73 374.076L1080.6 371.655L1078.93 372.185L1075.36 364.538L1081.22 362.684L1081.79 363.901L1077.89 365.139L1078.66 366.784L1104.12 358.733L1103.28 356.948L1099.19 358.243L1098.52 356.823L1104.86 354.822L1111.48 353.932L1111.78 355.477L1107.12 356.104L1107.47 357.915L1134.94 353.879L1134.42 351.483L1135.57 351.315L1137.18 358.745L1135.97 358.919L1136.54 361.656V361.656Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1523.76 697.73L1517.13 690.809L1520.09 688.891L1526.7 695.812L1523.76 697.73V697.73Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1533.57 837.35L1532.28 836.465L1533.33 835.43L1534.61 836.314L1533.57 837.35Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1527.47 871.197L1516.25 862.706"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1569.81 883.865L1569.71 882.722L1571.15 882.64L1571.24 883.785L1569.81 883.865Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1536.41 877.062L1538.35 874.753L1550.83 881.92L1548.87 884.228L1536.41 877.062V877.062Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1659.26 774.323L1656.47 785.642L1654.46 785.308L1657.25 773.984L1659.26 774.323Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1516.25 858.682L1529.9 869.015L1527.47 871.196"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1563.3 880.601L1566.89 880.79L1566.62 884.246L1563.03 884.057L1563.3 880.601V880.601Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1635.52 747.213L1636.9 746.605L1637.77 747.963L1636.39 748.569L1635.52 747.213Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1628.34 842.3L1630.16 840.828L1631.21 841.717L1629.39 843.183L1628.34 842.3Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1552.27 880.18L1559.77 880.439L1559.73 881.051L1562.12 881.138L1562.02 883.137L1552.12 882.793L1552.27 880.18V880.18Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1654.25 878.085L1651.02 879.458L1650.56 878.711L1653.79 877.338L1654.25 878.085Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1519.52 607.107L1516.25 603.874"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1516.25 599.022L1516.44 599.208L1516.25 599.334"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1516.25 600.164L1521.73 605.59L1519.51 607.106"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1516.83 591.948L1517.1 597.546L1516.25 597.575"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1516.25 591.967L1516.83 591.948"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1517.37 589.944L1516.25 590.729"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1516.25 589.37L1516.56 589.153L1517.37 589.944"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1542.53 500.168L1533.49 518.177L1525.83 515.57L1524.13 518.951L1516.25 516.267"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1516.25 501.147L1520.5 492.671L1542.53 500.168"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1518.21 536.055L1541.37 542.777L1532.15 564.358L1528.72 563.366L1528.2 558.236L1527.2 554.178L1526.05 550.635L1524.2 546.771L1521.76 543.383L1518.76 540.081L1517.26 538.606L1518.21 536.055V536.055Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M438.706 365.894L434.38 361.96L428.203 355.558L423.186 349.808L416.797 341.396L411.427 332.824L406.499 324.245L402.281 316.394L387.185 287.827L381.339 289.803L379.939 287.149L385.783 285.173L368.917 253.262L368.577 252.632L365.714 248.186L363.017 245.121L360.253 242.699L356.622 240.041L352.039 237.604L347.447 235.769L342.177 234.44L336.638 233.619L328.941 233.279L323.636 233.232L313.188 233.783L307.487 234.371L298.411 235.639L288.509 237.649L280.524 239.765L274.623 241.787L269.884 244.218L265.846 246.686L263.066 249.062L260.554 252.306L258.223 255.781L255.998 260.381L255.25 262.996L255.035 263.723L254.332 267.223L254.152 270.182L254.475 273.699L255.16 277.345L255.268 277.946L257.171 282.337L259.034 286.276L261.553 290.663L264.546 294.746L265.514 295.831L266.144 292.771L266.949 289.68L268.124 286.945L270.039 282.964L271.977 279.446L274.76 275.325L277.051 272.819L277.129 272.698L278.801 275.706L277.705 276.904L275.113 280.75L273.266 284.093L271.41 287.959L270.335 290.469L269.593 293.317L268.406 299.052L272.376 302.891L277.96 307.626L285.521 313.909L307.293 328.103L320.985 337.089L335.583 346.001L352.735 355.974L370.444 365.618L386.442 373.773L401.805 381.326L415.605 387.608L428.141 392.939L438.508 397.32"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M438.466 403.794L424.93 398.082L412.295 392.709L398.315 386.341L382.796 378.713L366.664 370.486L348.774 360.749L331.468 350.684L316.702 341.672L302.934 332.627L281.169 318.439L276.739 315.362L270.169 310.05L266.197 306.593L260.813 301.337L256.889 296.957L255.053 294.376L253.634 292.393L251.127 287.954L248.918 283.359L247.303 279.016L246.258 274.484L245.75 270.337L245.887 266.372L246.515 262.611L247.754 258.692L249.581 255.103L251.448 251.706L253.981 248.376L255.352 246.937L257.126 245.064L260.731 242.034L264.853 239.403L268.732 237.472L271.232 236.373L277.976 234.066L286.496 231.802L296.911 229.696L306.408 228.366L312.497 227.733L323.288 227.265L334.01 227.409L340.547 227.963L346.508 229.025L351.494 230.462L355.527 232.08L359.283 234.05L363.296 236.658L366.25 238.897L369.876 242.444L372.426 245.588L372.983 246.465L392.274 282.975L408.916 277.347L410.261 279.879L397.301 283.928L394.74 284.963L393.808 286.012L396.835 292.088L403.228 304.396L416.425 329.145L420.957 336.027L425.603 342.731L430.193 348.327L435.064 353.871L438.762 357.216"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M446.562 414.07L445.988 413.771L438.422 410.686"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M438.428 409.722L446.505 413.017L446.561 413.047"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M446.563 372.598L441.785 368.688L438.708 365.895H438.707"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M438.506 397.32H438.507L446.561 400.723"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M446.561 407.291L443.373 405.87L438.466 403.796H438.465"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M438.762 357.216L438.763 357.217L439.731 358.221L446.563 364.426"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M611.452 660.133L611.42 660.681L611.122 662.288L610.474 663.996L609.55 665.49L608.306 666.952L606.507 668.529L604.92 669.684L590.661 680.629L589.637 681.47L589.081 681.86L588.167 683.203L587.611 684.693L587.331 685.703L587.318 687.552L587.5 688.635L587.757 689.266L591.515 695.116L596.269 702.185L597.099 705.466L596.932 708.726L595.435 712.136L593.273 714.38L590.151 716.611L586.017 717.818L582.52 718.039L578.959 717.446L576.438 716.696L568.483 713.949L564 711.699L561.693 709.273L560.068 707.467L558.576 704.83L557.791 702.45L557.242 700.484L557.055 697.788L558.82 660.133"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M565.843 660.133L564.082 697.736L564.218 699.662L564.601 701.04L565.193 702.829L566.131 704.493L567.274 705.77L568.737 707.303L571.689 708.783L578.992 711.307L580.855 711.865L582.959 712.214L584.552 712.111L586.563 711.524L588.184 710.37L589.223 709.292L589.963 707.591L590.05 705.933L589.619 704.219L585.345 697.865L581.286 691.552L580.645 689.97L580.292 687.933L580.326 685.042L580.821 683.205L581.684 680.904L583.208 678.679L584.599 677.343L585.875 676.401L600.206 665.402L601.614 664.374L602.843 663.298L603.514 662.509L603.955 661.805L604.262 660.981L604.421 660.133"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M674.83 660.133L672.927 663.255L669.399 668.571L666.181 672.435L663.013 676.324L659.351 679.279L655.582 680.507L651.407 680.43L647.654 679.155L644.647 676.562L643.157 673.417L643.137 671.285L643.144 671.202L645.047 660.133"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M652.138 660.133L650.16 671.631L650.169 672.309L650.68 673.398L651.701 674.275L652.877 674.673L654.323 674.702L655.455 674.332L657.592 672.606L660.372 669.191L663.414 665.538L666.709 660.569L666.974 660.133"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M789.605 509.886L641.621 466.868L618.609 461.404L597.197 455.524L581.004 453.812L565.106 455.036L558.273 456.627L550.695 458.217L531.68 461.767L528.314 462.289L528.227 462.174L528.363 461.862L529.389 461.238L534.836 459.192L542.651 456.057L546.385 455.097L551.079 454.063L553.841 453.481L560.243 452.243L561.824 451.972L562.806 451.809"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M561.678 449.601L560.946 449.793L560.505 449.682L559.551 449.596L559.073 449.52L554.781 449.212L551.819 449.199L548.815 449.342L547.341 449.491L545.156 449.952L539.787 453.217L526.129 458.743L523.74 459.229L517.505 458.421L515.202 462.044L514.541 462.952"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M823.272 519.673L789.605 509.887"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M562.806 451.808L561.678 449.601"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M803.954 514.242L802.307 507.307"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M810.705 509.761L812.407 516.656"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M688.673 382.996L687.311 382.978"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M446.562 400.723L455.417 404.464L487.699 415.57L501.092 419.832L565.586 438.615L625.422 456.028L792.022 504.46"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M446.562 413.047L452.171 415.984L458.69 419.347L463.321 423.091L466.917 426.027L478.056 431.311L485.688 433.941L485.299 433.251L484.365 431.299L483.597 429.411L482.86 427.251L480.692 426L479.931 425.55L470.487 419.567L465.173 416.56L459.962 413.637L451.609 409.541L446.562 407.291"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M536.76 444.71L496.535 432.344L491.862 430.891L491.541 430.774L490.369 433.769L490.375 434.116L490.651 434.798L490.924 435.078L491.223 435.276L497.205 437.204L498.315 434.745L536.013 446.333L536.76 444.71V444.71Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M563.248 444.069L470.453 415.9L482.022 423.224L482.721 423.637L485.126 425.035L486.939 425.91L489.634 426.916L492.756 428.057L493.192 428.215L497.764 429.639L538.019 442.012L563.248 444.069V444.069Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M537.456 448.426L535.528 448.575L534.125 448.59L532.631 448.377L504.438 439.716L503.878 439.706L503.468 439.954L503.186 440.323L503.014 440.779L503.102 441.335L503.623 442.06L504.422 443.572L505.432 445.755L506.849 448.96L507.546 451.858L507.804 454.692L507.663 457.965L507.34 461.148L506.816 464.099L505.417 466.88L504.283 469.604L491.211 500.009L490.325 502.491L489.415 505.314L488.556 508.057L487.007 516.821L483.185 516.359L484.764 507.439L485.673 504.506L486.612 501.625L487.541 499.028L500.641 468.552L501.688 466.032L502.687 463.394L503.154 460.748L503.461 457.754L503.592 454.761L503.368 452.326L502.781 449.895L501.569 447.144L499.617 444.014L497.825 442.207L496.288 441.091L494.465 440.025L492.126 439.009L489.2 437.881L488.256 437.228L487.114 436.044L486.395 435.123L477.587 432.09L466.273 426.717L462.579 423.711L458.034 420.033L451.612 416.716L446.562 414.07"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M446.562 364.427L446.855 364.692L456.211 372.341L464.421 377.978L475.195 384.396L486.38 390.323L494.729 394.06L507.366 398.727L543.89 409.604L557.448 413.045L567.127 414.978L580.369 417.295L591.78 418.599L601.943 419.272L611.207 419.425L615.766 419.518L619.27 419.401L622.761 419.028L625.852 418.469L628.869 417.702L631.807 416.749L635.298 415.365L637.712 414.19L640 412.847L642.929 410.773L646.666 407.713L651.366 403.826L654.222 401.658L655.624 400.798L656.841 400.236L658.458 399.695L660.512 399.241L662.612 398.937L664.366 398.842L665.756 398.911L667.474 399.202L669.476 399.782L671.717 400.635L673.829 401.658L677.544 403.835L679.598 404.954L680.852 405.481L682.498 405.957L684.573 406.311L686.334 406.441L687.386 406.399L688.413 406.241L689.741 405.86L691.332 405.202L693.395 404.089L695.298 402.819L697.576 401.025L700.647 398.242L701.636 397.302L709.291 389.7L711.047 387.407L709.43 385.567L709.443 384.583L705.886 382.371L700.42 382.237L690.327 382.066L689.132 382.715L688.673 382.996"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M514.541 462.953L509.086 460.853L515.211 449.619L526.138 452.95L537.455 448.427"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M558.82 660.133L562.206 587.815L563.367 584.166L565.166 581.701L567.389 579.779L570.156 578.278L573.994 577.281L578.513 577.242L581.478 577.949L584.622 579.073L585.854 579.594L590.414 580.92L598.115 582.462L603.061 582.998L607.868 582.96L611.984 582.389L615.322 581.739L618.808 580.701L620.005 583.418L616.322 584.517L612.681 585.224L608.173 585.852L602.845 585.892L597.474 585.309L589.637 583.737L597.098 592.436L598.369 593.407L599.859 594.09L601.395 594.415L603.177 594.487L604.694 594.192L606.179 593.58L614.32 589.043L688.891 543.155L693.334 540.764L698.317 538.721L704.778 536.715L711.047 535.336L720.784 533.731L732.762 531.646L734.982 531.561L737.141 531.681L739.539 532.124L741.283 532.648L743.047 533.453L744.991 534.663L746.796 536.32L747.904 537.649L748.89 539.416L749.493 541.702L749.389 543.622L748.952 545.994L747.906 548.465L747.148 549.358L747.452 549.954L749.891 549.538L752.079 548.777L754.404 547.366L756.12 545.875L757.093 544.025L757.428 541.946L757.357 539.897L756.362 537.396L754.643 535.244L752.222 533.145L750.41 531.895L748.077 530.462L744.928 529.016L741.588 527.874L738.988 527.29L733.517 526.763L727.593 527.062L719.867 527.986L712.657 529.336L705.149 531.612L699.869 531.629L697.032 534.276L687.139 538.524L685.52 535.96L694.83 531.961L698.288 528.744L704.521 528.724L711.657 526.563L719.218 525.145L727.232 524.179L733.613 523.86L739.659 524.448L742.728 525.132L746.46 526.409L749.986 528.03L752.588 529.627L754.627 531.035L757.405 533.441L759.549 536.133L760.854 539.392L760.943 542.099L760.498 544.803L759.084 547.491L756.727 549.538L753.825 551.307L750.933 552.311L743.374 553.602L738.667 554.367L731.464 555.679L724.028 557.444L714.406 560.755L708.452 563.458L700.937 567.685L694.508 572.283L686.342 579.636L682.3 583.908L680.207 586.304L678.379 588.978L678.003 589.635L677.672 591.132L677.843 592.774L678.744 594.668L680.181 596.04L685.115 599.171L686.605 600.721L688.206 602.995L689.164 605.664L689.281 608.265L688.816 610.721L681.619 644.151L680.029 649.266L678.367 653.48L675.396 659.203L674.83 660.133"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M604.42 660.133L604.427 660.097L604.481 659.195L604.386 658.576L603.995 657.603L603.12 655.91L596.912 646.878L595.242 644.436L594.712 641.804L594.685 639.497L595.159 636.7L596.719 634.146L609.746 619.65L609.635 617.06L582.232 585.127L582.181 585.075L580.554 583.925L579.09 583.397L577.557 583.031L575.107 583.055L573.195 583.55L571.92 584.245L570.777 585.228L569.9 586.438L569.19 588.673L565.842 660.133"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M616.669 594.712L609.732 598.578L607.101 599.664L603.842 600.287L613.913 612.026L616.489 612.142L623.506 604.332L624.403 603.712L616.669 594.712H616.669Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M692.925 547.89L622.355 591.319L630.507 600.814L633.194 599.969L636.396 599.567L639.813 599.552L643.712 600.137L647.199 601.082L650.558 602.796L653.275 604.762L658.941 604.446L661.433 604.122L662.663 603.849L663.804 603.368L665.015 602.668L666.072 601.904L667.372 600.678L668.038 599.64L671.269 594.797L670.945 594.098L670.601 590.864L671.272 587.844L672.158 586.32L674.291 583.197L676.675 580.443L680.984 575.9L689.609 568.139L696.645 563.1L704.773 558.526L711.353 555.538L721.699 551.982L729.733 550.074L736.619 548.82L739.25 547.97L740.574 547.01L741.601 545.807L742.113 544.595L742.396 543.059L742.445 542.197L742.199 541.259L741.774 540.511L741.265 539.896L740.219 538.938L739.214 538.31L738.367 537.925L737.568 537.684L736.138 537.417L734.903 537.354L733.646 537.401L722.195 539.392L712.641 540.969L706.927 542.229L701.126 544.03L696.826 545.791L692.925 547.89V547.89Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M643.297 417.665L646.913 417.393L652.131 416.878L656.628 416.226L663.147 415.057L668.594 413.937L672.621 412.93L678.893 411.062L674.785 409.108L672.191 407.733L671.589 407.573L670.986 407.292L669.03 406.006L668.121 405.562L667.14 405.242L666.118 405.028L664.721 404.895L663.316 404.931L661.575 405.143L660.22 405.448L659.255 405.796L658.052 406.403L656.699 407.322L651.835 411.5L645.899 416L643.297 417.665V417.665Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M645.047 660.133L652.027 619.556L652.18 616.504L651.809 614.26L651.112 612.425L649.743 610.365L648.271 608.839L646.365 607.46L644.209 606.359L641.968 605.749L639.185 605.337L636.932 605.344L634.987 605.59L631.899 606.561L629.527 607.706L628.653 608.315L602.712 637.19L601.948 638.453L601.707 639.862L601.725 641.296L601.963 642.482L603.021 644.031L609.425 653.349L610.568 655.561L611.259 657.294L611.522 658.971L611.451 660.133"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M666.973 660.133L669.027 656.77L671.79 651.44L673.288 647.647L674.758 642.924L681.895 609.778L682.246 607.923L682.183 606.605L681.714 605.296L680.789 603.984L680.149 603.319L675.549 600.39L674.217 602.385L673.189 603.976L671.049 605.995L669.358 607.214L667.436 608.333L665.19 609.272L662.898 609.782L659.724 610.196L657.668 610.314L658.682 612.995L659.222 616.223L659.029 620.072L652.137 660.133"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M684.008 379.449L691.167 379.366L699.84 379.594L710.422 379.864L711.787 379.136L712.035 378.711L724.75 376.852L725.306 376.628L727.56 374.465L748.005 348.949L755.987 338.78L775.072 308.891L777.299 306.253L779.862 303.953L782.765 302.097L786.235 300.777L789.733 299.966L793.828 299.503L797.462 299.727L800.776 300.552L803.955 301.78L807.325 303.828L810.311 306.572L812.091 309.342L813.306 312.314L813.848 315.299L813.422 318.188L812.689 320.966L810.509 324.985L803.55 336.448L795.549 351.671L788.328 365.745L786.394 369.825L785.159 373.045L784.248 376.181L783.571 378.813L783.033 381.436L782.542 385.087L782.483 387.526L782.462 389.751L782.66 392.822L783.187 397.028L793.663 441.001L810.088 507.262L810.705 509.761"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M802.308 507.307L801.718 504.825L776.242 397.882L775.661 393.279L775.442 389.883L775.466 387.445L775.532 384.711L776.078 380.636L776.671 377.736L777.398 374.907L778.39 371.494L779.773 367.899L781.824 363.567L789.101 349.394L803.169 322.625L804.351 319.93L804.864 317.544L804.717 315.461L803.671 313.018L802.153 311.369L800.729 310.323L798.544 309.273L797.508 308.892L795.105 308.396L792.31 308.54L789.885 309.084L787.949 310.069L784.674 313.119L764.14 339.045L753.886 352.096L737.288 373.098L722.951 389.447L715.963 395.712L706.992 402.519L700.975 406.36L691.592 411.795L680.566 416.989L671.3 419.886L660.983 422.148L652.441 423.349L633.297 425.15L617.017 426.127L601.558 425.921L590.902 425.216L578.973 423.851L565.339 421.462L555.308 419.459L541.281 415.901L521.927 409.937L506.129 404.608L491.614 399.244L482.803 395.305L471.234 389.173L460.112 382.544L451.481 376.622L446.562 372.599"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M812.406 516.657L813.022 519.149L821.278 552.457L823.1 557.268L823.898 558.803L824.911 560.341L825.623 561.17L826.203 561.6L827.064 562.003L828.113 562.279L829.398 562.498L831.01 562.662L832.686 562.774L834.434 562.741L930.462 555.53L932.584 555.214L934.154 554.811L935.617 554.227L936.371 553.676L936.977 553.066L955.313 534.808L963.118 527.032L981.405 508.911"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M825.652 514.238L831.259 515.308L835.094 515.822L837.472 516.029L843.106 516.204L848.784 516.09L851.136 515.944L853.898 515.598L858.915 514.682L877.542 509.89L886.719 507.027L907.865 499.259L921.355 493.437L931.193 488.232L946.01 479.099L954.872 472.934L955.718 472.412L958.772 470.078L980.45 453.644L981.406 452.923"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M981.405 460.706L975.54 465.179L963.543 474.312L955.667 480.331L936.686 491.875L928.747 496.401L924.888 498.443L913.845 503.205L907.914 505.565L889.386 512.376L879.83 515.357L860.723 520.269L855.179 521.286L851.927 521.688L849.14 521.861L843.061 521.985L836.971 521.803L834.152 521.554L830.239 521.026L823.271 519.672"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M981.405 517.728L968.527 530.72L955.254 543.941L940.662 558.465L939.344 559.349L938.049 560.175L936.64 560.909L935.281 561.411L933.735 561.759L931.298 562.147L834.897 569.38L832.461 569.426L830.195 569.278L828.091 569.066L826.058 568.722L823.795 568.116L821.486 567.037L819.545 565.619L818.04 563.838L816.628 561.709L815.52 559.571L814.512 556.9L812.883 551.721L804.532 516.678L803.953 514.242"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M792.021 504.461L800.504 506.927L825.653 514.238"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1516.25 789.413L1510.54 782.152L1483.25 747.401L1479.59 742.917L1475.67 738.846L1471.38 735.206L1468.54 733.095L1465.24 731.127L1460.93 728.962L1456.38 727.267L1452.78 726.383L1448.45 725.486L1445.05 725.124L1439.8 724.972L1430.26 725.053L1422.46 725.029L1416.78 724.848L1413.84 724.575L1411.05 724.163L1406.48 723.176L1402.18 722.165L1398.47 720.852L1394.69 719.211L1391.15 717.351L1388.28 715.686L1383.33 712.31L1378.74 708.174L1374.86 703.451L1372.3 699.507L1370.12 694.774L1363.44 674.973L1359.43 662.994L1358.52 660.133"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1365.97 660.133L1367 663.236L1369.68 670.417L1370.66 672.913L1376.66 690.589L1378.41 694.83L1379.96 697.957L1382.67 702.074L1384.78 704.362L1386.63 706.214L1388.52 707.761L1390.42 709.155L1392.65 710.693L1395.4 712.369L1398.46 713.776L1401.8 715.183L1405.04 716.343L1408.69 717.302L1412.17 717.948L1415.16 718.458L1419.79 718.709L1423.95 718.855L1432.8 718.814L1437.35 718.702L1441.81 718.807L1445.37 718.974L1449.81 719.514L1453.81 720.202L1458.14 721.331L1461.58 722.445L1465.52 724.036L1469.73 726.21L1473.79 728.558L1476.74 730.636L1479.41 733.053L1482.01 735.896L1485.08 739.656L1488.01 743.178L1516.25 778.906"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1486.27 603.155L1495.22 612.11L1516.25 633.474"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1479.08 608.007L1474.57 603.539"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1481.58 598.461L1486.27 603.155"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M989.08 472.96L989.358 472.743L1003.35 458.583L1005.35 459.119"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1477.68 594.621L1481.58 598.46"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1039.93 419.055L1027.84 425.333L985.401 457.66L981.406 460.706"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M981.406 508.911L987.325 503.046L1003.44 486.918L1004.64 484.951L1005.39 481.839L1005.23 477.837L1004.35 474.717L1002.55 471.079L1000.7 469.193L999.858 468.551L999.045 468.249L998.182 468.157L997.177 468.593L990.951 474.045L989.082 472.96"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M981.406 452.923L1029.55 416.542L1039.88 408.753L1048.95 402.334L1051.6 400.657L1055.45 398.218L1061.13 394.798L1064.04 393.307L1070.93 389.297L1075.64 386.79L1078.98 385.21L1083.99 383.115L1090.4 380.744L1096.24 378.77L1104.47 376.252L1112.16 374.175L1119.25 372.564L1122.65 371.967L1124.42 371.823H1125.5L1125.86 371.858L1126.2 371.924L1126.51 372.042L1126.79 372.209L1127.04 372.42L1127.45 372.901L1128.14 374.222L1128.75 375.884L1129.85 379.588L1131.31 385.908L1131.52 386.464L1131.82 386.981L1132.25 387.433L1132.78 387.816L1133.39 388.132L1134.04 388.372L1134.72 388.53L1135.42 388.615L1136.13 388.613L1136.84 388.529L1137.49 388.347L1138.1 388.055L1140.38 386.568L1141.69 385.705L1145.15 383.732L1149.31 381.599L1153 379.91L1156.47 378.503L1160.67 377.03L1164.31 375.977L1168.36 375.048L1172.82 374.241L1181.13 373.069L1186.63 372.532L1193.45 372.295L1199.49 372.438L1203.09 372.811L1208.3 373.615L1214.87 375.043L1219.21 376.063L1227.9 378.46L1234.53 380.559L1242.31 383.281L1249.53 386.222L1257.33 389.812L1266.79 394.732L1275.66 399.933L1285.46 406.377L1292.27 411.392L1297.49 415.658L1302.69 420.607L1311.5 429.352L1332.99 450.531L1341.84 459.508L1437.46 554.295L1477.72 594.597"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1062.63 403.454L1061.42 404.23L1051.86 410.342L1050.3 411.344L1045.92 414.221L1043.41 416.088L1039.93 419.055"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1005.35 459.119L1004.25 460.271L1004.21 461.061L1002.35 462.8L1001.72 464.109L1001.67 464.468L1002.09 464.544L1006.32 461.463L1011.22 454.97L1012.9 452.723L1014.93 453.656L1012.33 456.861L1008.61 461.463L1007.52 462.684L1004.95 465.418L1005.27 465.552L1008.34 462.947L1011.66 465.303L1013.79 466.342L1015.06 466.8L1016.41 467.093L1018.16 467.269L1021.35 467.295L1024.14 467.127L1026.23 466.859L1027.59 466.559L1028.87 466.118L1030.65 465.208L1034.88 462.555L1038.99 460.347L1046.57 456.727L1053.39 453.732L1057.82 451.983L1063.67 449.991L1067.21 448.736L1070.31 447.401L1072.72 446.238L1081.88 441.811L1085.15 440.229L1088.22 438.831L1089.08 438.321L1089.86 437.718L1090.28 437.256L1090.61 436.75L1090.83 436.202L1091.02 435.334L1091.07 434.468L1090.94 433.612L1090.66 432.79L1090.11 431.723L1089.2 430.366L1084.41 422.182L1077.87 410.116L1072.74 400.821L1072.13 399.98L1071.51 399.821L1070.01 399.78L1067.24 401.045L1062.63 403.454"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1140.24 408.656L1137.56 409.153L1133.42 409.765L1128.55 410.322L1119.82 411.04L1116.67 411.2L1114.21 411.154L1112.46 410.98L1110.75 410.636L1109.44 410.213L1107.9 409.531L1098.87 404.717L1093.11 401.546L1091.17 400.403L1088.52 398.987L1086.35 398.047L1085.02 397.649L1083.64 397.406L1082.6 397.343L1081.21 397.4L1078.76 397.737L1098.75 432.876L1100.01 434.854L1101.33 436.565L1102.48 437.679L1103.27 438.262L1104.15 438.727L1105.11 439.08L1106.47 439.392L1108.56 439.637L1111.71 439.703L1116.27 439.463L1125.04 439.438L1130.66 439.602L1135.9 439.926L1140.04 440.296L1142.89 440.551L1149.5 441.372L1154.99 442.27L1158.42 442.863L1159.82 443.02L1160.53 443.022L1161.21 442.938L1161.88 442.768L1163.15 442.241L1164.62 441.417L1165.65 440.635L1166.31 439.961L1166.87 439.217L1167.29 438.415L1167.55 437.567L1167.67 436.7L1167.62 435.834L1167.34 434.704L1166.01 430.796L1164.18 424.324L1163.03 419.503L1162.58 416.628L1162.43 414.317L1162.55 411.721L1162.95 409.133L1163.98 404.823L1165.33 401.512L1160.97 403.163L1156.45 404.737L1153.16 405.736L1148.81 406.861L1143.04 408.131L1140.24 408.656V408.656Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1090.47 387.325L1090.62 387.354L1091.55 388.019L1098.28 393.088L1104.2 397.155L1107.37 399.466L1108.72 400.39L1109.62 400.839L1110.57 401.179L1111.6 401.415L1113.02 401.605L1114.79 401.654L1116.19 401.54L1117.54 401.255L1118.83 400.821L1121.02 399.859L1125.47 396.851L1129.84 393.951L1128.31 393.117L1127.24 392.367L1126.55 391.715L1125.58 390.509L1125.13 389.727L1124.71 388.621L1123.34 382.418L1123.2 381.37L1122.88 379.94L1122.65 379.384L1122.47 379.135L1122.25 378.914L1121.97 378.734L1121.65 378.6L1121.3 378.506L1120.96 378.463L1120.61 378.468L1119.91 378.552L1112.07 380.344L1107.3 381.623L1100.41 383.727L1090.61 387.292L1090.47 387.325V387.325Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1358.52 660.133L1356.97 655.155L1355.48 651.294L1354.22 648.593L1352.72 645.979L1350.98 643.468L1349.04 641.054L1346.9 638.751L1344.61 636.567L1342.1 634.532L1339.71 632.833L1336.34 630.754L1332.79 628.876L1329.1 627.213L1325.25 625.785L1322.29 624.883L1318.57 624.01L1314.78 623.392L1310.94 623.016L1307.08 622.843L1285.87 622.264L1274.6 621.688L1269.37 621.208L1265.93 620.667L1262.52 619.951L1259.17 619.098L1255.88 618.108L1251.69 616.602L1247.64 614.874L1243.73 612.944L1240 610.781L1236.44 608.424L1233.35 606.069L1230.45 603.549L1227.76 600.882L1225.47 598.322L1223.36 595.66L1220.96 592.123L1218.9 588.448L1217.09 584.681L1216.04 581.926L1215.53 579.952L1215.05 577.082L1214.77 573.607L1214.76 570.138L1214.97 567.543L1215.51 564.389L1216.35 561.282L1217.46 558.235L1219.81 552.787L1223.37 544.479L1234.84 518.745L1235.76 516.256L1236.35 513.999L1236.87 510.551L1237.14 507.378L1237.12 504.492L1236.84 501.605L1236.15 497.879L1235.26 494.481L1234.17 491.435L1232.74 488.483L1231.22 485.874L1229.01 482.58L1227.3 480.392L1224.98 477.85L1222.69 475.661L1220.24 473.58L1217.9 471.824L1215.15 470.037L1212.52 468.591L1207.66 466.262L1200.5 463.196L1197.82 462.087L1189.54 458.599L1180.31 455.031L1172.77 452.582L1164.83 450.418L1157.93 448.869L1149.72 447.433L1144.73 446.699L1140 446.188L1137.75 445.946L1129.77 445.402L1117.06 445.722L1108.27 446.036L1103.03 446.372L1098.14 446.865L1091.92 447.75L1088.16 448.463L1084.12 449.434L1079.49 450.794L1076.6 451.769L1072.66 453.094L1063.05 456.62L1055.77 459.494L1049.87 462.065L1043.52 465.136L1039.08 467.47L1034.45 470.093L1029.68 473.037L1024.55 476.541L1020.92 479.278L1017.2 482.347L1013.4 485.753L1008.14 490.794L998.246 500.737L981.406 517.728"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1140.34 393.997L1134.26 398.12L1128.16 402.51L1125.69 404.13L1123.63 405.219L1121.44 406.14L1119.16 406.894L1117.8 407.171L1116.05 407.33L1113.93 407.31L1111.15 407.038L1108.4 406.506L1106.42 405.912L1105.19 405.37L1103.47 404.356L1086.88 392.178L1085.52 391.264L1084.61 390.838L1083.94 390.631L1083.24 390.525L1082.9 390.523L1082.56 390.567L1082.23 390.643L1081.57 390.876L1076.25 393.339L1078.08 396.323L1079.4 395.983L1080.77 395.751L1082.17 395.695L1084.28 395.842L1086 396.145L1087.3 396.55L1089.49 397.501L1097.63 402.053L1102.95 404.915L1105.9 406.465L1107.78 407.225L1109.77 407.8L1112.52 408.326L1114.61 408.551L1116.71 408.565L1130.31 407.277L1134.81 406.674L1139.62 405.833L1140.26 405.702L1144.39 404.854L1149.44 403.64L1154.42 402.227L1159.65 400.54L1167.22 397.601L1167.08 397.537L1168.37 395.113L1170.01 392.561L1171.37 390.867L1172.89 389.278L1175.79 386.759L1180.86 383.139L1183.27 381.611L1176.48 381.413L1170.61 381.394L1166.83 381.55L1161.9 383.048L1158.67 384.156L1155.2 385.564L1151.25 387.443L1147.13 389.65L1143.72 391.693L1140.34 393.997V393.997Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1182.6 426.863L1182.08 425.883L1181.46 424.66L1179.9 420.093L1178.73 414.358L1178.45 413.819L1177.9 413.493L1174.11 413.117L1173.39 413.201L1171.78 414.079L1169.15 415.866L1169.16 417.987L1169.38 419.416L1170.46 422.774L1172.92 429.705L1174.74 434.396L1176.68 438.717L1181.77 448.59L1182.15 449.06L1182.39 449.258L1182.66 449.433L1183.59 449.876L1197.89 455.628L1208.05 460.043L1215.38 463.308L1221.67 467.075L1226.73 470.936L1231.89 475.851L1236.59 481.873L1239.42 486.816L1241.37 491.405L1243.12 498.477L1243.98 505.267L1243.56 511.955L1242.57 517.189L1239.23 525.538L1233.54 538.65L1224.19 559.413L1223.16 562.178L1222.38 564.991L1221.91 567.862L1221.61 571.625L1221.61 574.238L1221.86 576.828L1222.41 579.387L1223.25 581.893L1224.29 584.36L1226.04 587.838L1227.93 590.932L1230.12 593.909L1232.35 596.508L1234.78 598.974L1237.41 601.312L1240.98 604.102L1243.67 605.953L1246.5 607.665L1249.46 609.227L1253.44 611.055L1256.62 612.3L1259.55 613.272L1262.55 614.089L1266.63 614.94L1270.43 615.522L1274.26 615.957L1278.1 616.222L1283.36 616.362L1285.39 616.387L1298.46 616.723L1312.79 617.55L1317.31 618.061L1320.4 618.593L1324.46 619.548L1329.41 621.022L1332.62 622.192L1335.72 623.559L1338.68 625.092L1341.56 626.77L1344.82 628.953L1347.64 631.122L1350.33 633.411L1352.66 635.577L1354.62 637.628L1356.35 639.798L1359.09 643.833L1360.69 646.407L1361.93 648.793L1363.18 651.811L1364.97 657.104L1365.97 660.133"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1192.28 383.821L1193.55 386.582L1195.92 386.24L1200.08 385.732L1203.22 385.503L1210.25 385.354L1210.14 385.337L1207.3 384.572L1203.28 383.797L1200.05 383.268L1195.43 382.739L1195.18 382.837L1192.28 383.821V383.821Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1479.08 608.007L1495.11 627.058L1483.68 616.933L1478.13 611.455L1476.7 610.053L1471.74 605.174V605.173L1462.38 595.962L1354.38 488.644L1327.52 460.022L1295.72 428.69L1283.65 418.093L1279.95 415.04L1265.87 406.124L1256.01 400.628L1249.31 397.148L1243.62 394.347L1238.64 392.018L1234.73 390.417L1231.52 389.258L1229.5 388.574L1227.32 387.875L1217.32 384.35L1214.35 383.464L1209.28 382.298L1204.74 381.284L1205.69 381.154L1209.54 381.015L1212 381.119L1214.08 381.359L1216.1 381.692L1219.46 382.481L1225.44 384.287L1234.55 387.526L1242.68 390.821L1249.65 394.045L1256.07 397.392L1268.45 406.969L1277.06 412.446L1283.27 416.847L1309.63 439.727L1338.88 468.704L1365.76 495.458L1416.36 545.788L1454.15 583.263L1474.57 603.539"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1542.5 660.133L1569.41 687.427L1594.75 713.169"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1521.13 660.133L1528.25 666.975L1528.62 667.325L1529.31 667.593L1530.26 667.625L1530.98 667.6L1531.76 667.308L1532.36 666.833L1532.61 666.053L1532.55 665.197L1532.35 664.606L1527.26 660.133"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1595.08 725.08L1565.52 695.598L1552.32 682.559L1546.33 676.769L1543.46 674.212L1538.89 677.498L1590.56 728.644L1591.52 729.002L1592.6 729.075L1593.75 728.843L1594.62 728.466L1595.15 727.695L1595.3 726.989L1595.33 726.284L1595.17 725.404L1595.08 725.08V725.08Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1516.25 778.906L1516.95 779.793L1532.1 798.771L1539.69 808.182L1544.38 813.932L1548.06 818.145L1549.89 820.032L1551.06 821.038L1552.25 822.043L1553.46 823.003L1554.39 823.655L1555.33 824.277L1556.31 824.877L1557.14 825.36L1557.89 825.781L1558.71 826.206L1559.58 826.619L1560.48 827.011L1562.13 827.724L1562.9 828.04L1563.68 828.333L1564.45 828.579L1565.22 828.807L1566.01 829.019L1566.94 829.283L1567.89 829.53L1568.85 829.755L1569.95 829.99L1571.06 830.199L1572.19 830.382L1573.11 830.496L1576.22 830.834L1578.96 830.96L1581.39 830.914L1583.54 830.709L1585.99 830.392L1588.08 830.06L1590.01 829.675L1592.84 828.837L1595.4 827.855L1596.23 827.523L1598.78 826.315L1599.91 825.679L1600.11 825.557L1602.51 824.134L1604.46 822.825L1606.3 821.452L1608.13 819.869L1608.59 819.426L1610.61 817.344L1612.67 814.659L1614.67 810.5L1622.64 790.45L1624.39 784.706L1625.28 780.085L1625.78 775.779L1625.91 772.798L1625.57 769.137L1624.93 765.613L1624 761.192L1622.32 756.772L1620.45 752.556L1617.64 748.537L1615.58 745.753L1610.93 740.794L1606.2 736.144L1602.36 738.571L1601 739.427L1600.37 739.701L1599.4 739.778L1598.19 739.628L1597.15 738.976L1590.75 732.444L1536.78 679.021L1535.4 680.02L1516.99 661.734L1519.34 660.133"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1594.62 712.974L1599.82 718.314L1611.77 730.507L1617.32 736.343L1619.46 738.942L1622.35 742.886L1625.69 748.227L1628.43 754.094L1630.13 758.756L1631.68 764.522L1632.27 768.779L1632.53 773.671L1632.29 778.375L1631.96 780.941L1631.53 783.598L1630.95 785.966L1629.54 790.521L1628.41 794.916L1621.33 812.431L1619.42 816.314L1618.33 818.199L1617.28 819.715L1616.13 821.195L1614.91 822.63L1613.63 824.022L1612.3 825.376L1612.04 825.611L1610.87 826.652L1609.08 828.043L1607.16 829.337L1605.18 830.541L1603.12 831.67L1600.98 832.719L1598.79 833.658L1596.19 834.611L1593.51 835.42L1590.78 836.097L1587.74 836.677L1584.66 837.092L1581.56 837.333L1578.32 837.394L1575.07 837.258L1571.86 836.953L1567.92 836.33L1564.02 835.434L1561.33 834.577L1556.52 832.661L1553.13 831.025L1550.25 829.267L1547.6 827.225L1545.43 825.435L1545.28 825.308L1543.46 823.479L1541.75 821.517L1533.41 811.276L1516.25 789.413"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1516.25 633.474L1537.57 655.135L1542.5 660.133"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1519.34 660.134L1520.39 659.42L1521.13 660.134"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1527.26 660.133L1516.25 650.443"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1223.85 543.406L1223.37 544.478L1219.81 552.786L1217.46 558.234L1216.35 561.282L1215.51 564.389L1214.97 567.542L1214.75 570.138L1214.77 573.606L1215.05 577.081L1215.53 579.952L1216.04 581.925L1217.09 584.681L1218.9 588.447L1220.96 592.122L1223.36 595.659L1225.47 598.321L1227.76 600.881L1230.45 603.548L1233.35 606.068L1236.44 608.423L1240 610.781L1243.73 612.943L1247.64 614.874L1251.69 616.602L1255.87 618.107L1259.17 619.097L1262.52 619.95L1265.93 620.666L1269.37 621.207L1274.6 621.688L1285.87 622.263L1307.08 622.842L1310.94 623.015L1314.78 623.391L1318.57 624.009L1322.29 624.882L1325.25 625.785L1329.09 627.212L1332.79 628.875L1336.33 630.753L1339.71 632.832L1342.1 634.531L1344.61 636.566L1346.9 638.75L1349.03 641.053L1350.98 643.468L1352.72 645.979L1354.21 648.593L1355.48 651.293L1356.96 655.155L1358.52 660.133L1359.43 662.994L1363.44 674.973L1370.12 694.774L1372.3 699.507L1374.86 703.451L1378.74 708.173L1383.33 712.309L1388.28 715.686L1391.15 717.351L1394.69 719.211L1398.47 720.851L1402.18 722.165L1406.47 723.176L1411.05 724.163L1413.84 724.575L1416.77 724.848L1422.46 725.029L1430.26 725.052L1439.79 724.972L1445.05 725.123L1448.45 725.486L1452.78 726.383L1456.38 727.267L1460.93 728.962L1465.23 731.126L1468.54 733.095L1471.38 735.206L1475.67 738.846L1479.59 742.916L1483.25 747.4L1510.54 782.152L1516.25 789.412L1533.41 811.276L1541.75 821.517L1543.46 823.478L1545.28 825.308L1545.43 825.435L1547.6 827.224L1550.25 829.266L1553.13 831.025L1556.52 832.66L1561.33 834.577L1564.02 835.434L1567.92 836.329L1571.86 836.953L1575.07 837.257L1578.31 837.393L1581.56 837.333L1584.66 837.092L1587.74 836.677L1590.78 836.097L1593.51 835.419L1596.18 834.61L1598.79 833.658L1600.98 832.719L1603.11 831.669L1605.17 830.54L1607.16 829.336L1609.08 828.042L1610.87 826.651L1612.03 825.611L1612.3 825.376L1613.63 824.022L1614.91 822.629L1616.12 821.195L1617.28 819.715L1618.33 818.199L1619.42 816.313L1621.32 812.43L1628.41 794.915L1629.53 790.521L1630.94 785.966L1631.53 783.598L1631.95 780.94L1632.28 778.375L1632.53 773.67L1632.27 768.779L1631.68 764.521L1630.13 758.756L1628.43 754.094L1625.69 748.227L1622.34 742.886L1619.46 738.942L1617.32 736.342L1611.77 730.507L1599.82 718.314L1594.62 712.973L1594.75 713.169L1569.41 687.427L1542.5 660.133L1537.57 655.135L1516.25 633.474L1495.22 612.109L1486.27 603.155L1481.58 598.461V598.46L1477.68 594.621L1477.72 594.596L1437.46 554.294L1341.83 459.507L1332.99 450.53L1311.5 429.351L1302.69 420.606L1299.89 417.952"
          stroke="#22DB4B"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path d="M812.37 516.504L803.906 514.044" stroke="#FFF38A" stroke-width="0.1" />
        <path
          d="M1499.93 636.093L1516.25 650.444L1527.26 660.133L1532.35 664.606L1543.46 674.212L1546.33 676.769L1552.32 682.559L1565.52 695.598L1595.08 725.08L1606.2 736.144L1610.93 740.795L1615.58 745.753L1617.64 748.537L1620.45 752.556L1622.31 756.772L1624 761.192L1624.93 765.614L1625.57 769.137L1625.91 772.798L1625.77 775.78L1625.28 780.086L1624.38 784.706L1622.64 790.45L1614.67 810.5L1612.67 814.659L1610.61 817.344L1608.58 819.426L1608.13 819.869L1606.3 821.452L1604.45 822.825L1602.51 824.134L1600.11 825.557L1599.91 825.679L1598.78 826.315L1596.23 827.523L1595.4 827.856L1592.84 828.837L1590 829.675L1588.08 830.06L1585.99 830.392L1583.54 830.709L1581.39 830.914L1578.96 830.961L1576.22 830.834L1573.11 830.496L1572.19 830.382L1571.06 830.199L1569.95 829.99L1568.85 829.755L1567.89 829.53L1566.94 829.283L1566.01 829.02L1565.22 828.808L1564.45 828.579L1563.68 828.333L1562.9 828.04L1562.13 827.724L1560.48 827.012L1559.58 826.62L1558.7 826.206L1557.89 825.781L1557.14 825.36L1556.3 824.877L1555.33 824.277L1554.39 823.656L1553.46 823.003L1552.25 822.043L1551.06 821.038L1549.89 820.032L1548.05 818.146L1544.38 813.932L1539.69 808.182L1532.1 798.771L1516.95 779.793L1516.25 778.906L1488.01 743.178L1485.08 739.656L1482.01 735.896L1479.41 733.053L1476.74 730.636L1473.79 728.558L1469.73 726.211L1465.52 724.036L1461.58 722.445L1458.14 721.331L1453.81 720.202L1449.81 719.514L1445.37 718.975L1441.81 718.807L1437.35 718.702L1432.8 718.814L1423.95 718.855L1419.79 718.709L1415.16 718.458L1412.17 717.949L1408.69 717.302L1405.04 716.343L1401.8 715.183L1398.46 713.776L1395.4 712.37L1392.65 710.693L1390.42 709.156L1388.52 707.761L1386.63 706.214L1384.78 704.362L1382.67 702.074L1379.96 697.957L1378.41 694.83L1376.66 690.59L1370.66 672.913L1369.69 670.417L1367 663.236L1365.97 660.133L1364.97 657.104L1363.18 651.811L1361.93 648.794L1360.69 646.407L1359.09 643.833L1356.35 639.798L1354.62 637.629L1352.66 635.578L1350.33 633.411L1347.64 631.122L1344.82 628.953L1341.56 626.77L1338.68 625.093L1335.72 623.559L1332.62 622.192L1329.41 621.022L1324.46 619.549L1320.4 618.593L1317.31 618.061L1312.79 617.55L1298.46 616.723L1285.39 616.387L1283.36 616.362L1278.1 616.222L1274.26 615.958L1270.43 615.522L1266.63 614.94L1262.55 614.089L1259.55 613.273L1256.62 612.3L1253.44 611.055L1249.46 609.227L1246.5 607.665L1243.67 605.953L1240.98 604.102L1237.41 601.312L1234.78 598.975L1232.35 596.508L1230.12 593.909L1227.93 590.932L1226.04 587.838L1224.29 584.361L1223.25 581.893L1222.41 579.387L1221.86 576.828L1221.61 574.238L1221.61 571.625L1221.91 567.863L1222.38 564.991L1223.16 562.179L1224.19 559.413L1230.07 546.338"
          stroke="#22DB4B"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M1299.9 417.952L1297.49 415.657L1292.27 411.391L1285.46 406.376L1275.66 399.933L1266.79 394.731L1257.33 389.811L1249.53 386.221L1242.31 383.28L1234.53 380.558L1227.9 378.46L1219.21 376.063L1214.87 375.043L1208.3 373.614L1203.09 372.811L1199.49 372.437L1193.45 372.294L1186.63 372.532L1181.13 373.068L1172.82 374.24L1168.36 375.047L1164.31 375.976L1160.67 377.029L1156.47 378.503L1153 379.91L1149.31 381.598L1145.15 383.731L1141.69 385.705L1140.38 386.567L1138.1 388.054L1129.84 393.949L1125.47 396.849L1121.02 399.858L1118.83 400.82L1117.54 401.254L1116.19 401.538L1114.79 401.653L1113.02 401.604L1111.6 401.414L1110.57 401.178L1109.62 400.837L1108.72 400.389L1107.37 399.465L1104.2 397.154L1098.28 393.087L1091.55 388.017L1090.62 387.352L1090.47 387.324L1087.35 385.826L1084.1 385.079H1080.65L1078.98 385.21L1075.64 386.79L1070.93 389.297L1064.04 393.306L1061.13 394.797L1055.45 398.217L1051.6 400.656L1048.95 402.334L1039.87 408.753L1029.55 416.541L981.406 452.923L980.45 453.644L958.771 470.078L955.717 472.412L954.872 472.933L946.01 479.099L931.193 488.232L921.355 493.437L907.864 499.259L886.718 507.027L877.541 509.89L858.915 514.682L853.898 515.598L851.135 515.944L848.784 516.09L843.106 516.204L837.472 516.029L835.094 515.822L831.259 515.308L825.652 514.237L810.74 509.903"
          stroke="#FFF38A"
          stroke-width="0.1"
        />
        <path d="M802.344 507.462L810.74 509.903" stroke="#FFF38A" stroke-width="0.1" />
        <path
          d="M776.98 506.215L789.606 509.886V509.887L803.907 514.044"
          stroke="#FFF38A"
          stroke-width="0.1"
        />
        <path
          d="M808.875 502.368L793.663 441L783.187 397.027L782.66 392.821L782.462 389.75L782.483 387.525L782.542 385.086L783.033 381.435L783.571 378.813L784.248 376.18L785.159 373.044L786.394 369.824L788.328 365.744L795.55 351.67L803.55 336.448L810.509 324.984L812.689 320.965L813.422 318.187L813.848 315.299L813.306 312.313L812.091 309.341L810.311 306.571L807.325 303.828L803.955 301.779L800.777 300.552L797.462 299.727L793.828 299.503L789.733 299.966L786.235 300.776L782.765 302.096L779.862 303.953L777.299 306.252L775.072 308.89L755.987 338.779L748.005 348.948L727.56 374.464L725.306 376.627L711.047 387.406L709.291 389.699L701.637 397.301L700.647 398.241L697.577 401.025L695.298 402.819L693.395 404.088L691.332 405.201L689.742 405.86L678.893 411.062L672.621 412.93L668.593 413.936L663.147 415.057L656.627 416.226L652.131 416.878L646.913 417.392L643.297 417.665L619.271 419.4L615.767 419.517L611.207 419.424L601.944 419.272L591.78 418.598L580.369 417.295L567.127 414.977L557.448 413.044L543.89 409.604L507.367 398.727L494.729 394.059L486.38 390.323L475.196 384.396L464.421 377.977L456.211 372.34L446.855 364.692L446.563 364.426L439.731 358.221L438.763 357.217L438.762 357.216L435.063 353.871L430.193 348.327L425.603 342.731L420.957 336.027L416.425 329.145L403.227 304.396L396.834 292.088L393.807 286.012L392.274 282.975L372.982 246.465L372.425 245.588L369.876 242.444L366.25 238.897L363.296 236.658L359.283 234.05L355.527 232.08L351.493 230.462L346.507 229.025L340.547 227.963L334.01 227.409L323.288 227.265L312.497 227.733L306.408 228.366L296.911 229.696L286.496 231.802L277.976 234.066L271.232 236.373L268.732 237.472L264.853 239.403L260.731 242.034L257.126 245.064L255.352 246.937L253.981 248.376L251.448 251.706L249.581 255.103L247.754 258.692L246.515 262.611L245.887 266.372L245.75 270.337L246.258 274.484L247.303 279.016L248.918 283.359L251.127 287.954L253.633 292.393L255.053 294.376L256.889 296.957L260.813 301.337L266.197 306.593L270.169 310.05L276.739 315.362L281.169 318.439L302.934 332.627L316.702 341.672L331.468 350.684L348.773 360.749L366.664 370.486L382.796 378.713L398.314 386.341L412.295 392.709L424.93 398.082L438.465 403.794V403.795H438.466L443.373 405.869L446.562 407.29H446.563L451.61 409.54L459.963 413.636L470.454 415.9L563.249 444.069L597.198 455.523L618.61 461.404L641.622 466.868L776.98 506.215"
          stroke="#64E3FF"
          stroke-width="0.1"
        />
        <path
          d="M778.574 500.55L625.422 456.028L565.586 438.614L501.092 419.831L487.699 415.57L455.417 404.463L446.563 400.722H446.562L438.507 397.32H438.506L428.141 392.939L415.605 387.608L401.805 381.326L386.442 373.773L370.443 365.618L352.734 355.974L335.582 346.001L320.985 337.089L307.293 328.103L285.521 313.909L277.96 307.626L272.376 302.891L268.406 299.052L265.514 295.831L264.546 294.746L261.553 290.663L259.034 286.275L257.171 282.337L255.268 277.946L255.16 277.345L254.475 273.699L254.152 270.182L254.332 267.223L255.035 263.723L255.25 262.996L255.998 260.381L258.223 255.781L260.554 252.306L263.066 249.062L265.846 246.686L269.884 244.218L274.623 241.787L280.524 239.765L288.509 237.648L298.411 235.639L307.487 234.371L313.188 233.783L323.636 233.232L328.941 233.279L336.638 233.619L342.177 234.44L347.446 235.769L352.039 237.604L356.621 240.041L360.253 242.699L363.016 245.121L365.714 248.186L368.577 252.632L368.917 253.262L385.783 285.173L387.184 287.827L402.28 316.394L406.499 324.245L411.426 332.824L416.797 341.396L423.186 349.808L428.202 355.558L434.38 361.96L438.706 365.894H438.707L441.784 368.687L446.562 372.598H446.563L451.481 376.621L460.112 382.543L471.234 389.172L482.803 395.304L491.614 399.243L506.129 404.607L521.927 409.936L541.281 415.9L555.308 419.458L565.339 421.462L578.973 423.85L590.902 425.215L601.558 425.92L617.017 426.126L633.297 425.149L652.441 423.348L660.983 422.147L671.3 419.885L680.567 416.988L691.592 411.794L700.975 406.359L706.992 402.518L715.963 395.711L722.951 389.446L737.289 373.097L753.886 352.095L764.14 339.044L784.674 313.118L787.949 310.068L789.885 309.084L792.31 308.538L795.105 308.395L797.508 308.891L798.544 309.272L800.729 310.322L802.153 311.368L803.671 313.017L804.717 315.46L804.864 317.543L804.351 319.929L803.169 322.624L789.101 349.393L781.824 363.566L779.773 367.898L778.39 371.493L777.398 374.906L776.671 377.735L776.078 380.635L775.532 384.71L775.466 387.444L775.442 389.882L775.661 393.278L776.242 397.881L801.47 503.785"
          stroke="#64E3FF"
          stroke-width="0.1"
        />
        <path
          d="M802.344 507.462L800.503 506.926L792.02 504.461L792.021 504.46L778.574 500.55"
          stroke="#FFF38A"
          stroke-width="0.1"
        />
        <path
          d="M803.906 514.045L803.954 514.242L804.532 516.678L812.883 551.721L814.513 556.9L815.52 559.571L816.628 561.709L818.04 563.838L819.545 565.619L821.487 567.036L823.796 568.116L826.059 568.722L828.092 569.066L830.196 569.278L832.462 569.426L834.898 569.38L931.299 562.147L933.736 561.759L935.282 561.411L936.64 560.909L938.049 560.175L939.345 559.349L940.662 558.465L955.255 543.941L968.528 530.72L981.406 517.728L998.245 500.737L1008.14 490.794L1013.4 485.753L1017.2 482.347L1020.92 479.278L1024.54 476.541L1029.67 473.037L1034.45 470.093L1039.08 467.47L1043.52 465.136L1049.87 462.065L1055.76 459.494L1063.05 456.62L1072.66 453.094L1076.6 451.769L1079.48 450.794L1084.12 449.434L1088.16 448.463L1091.92 447.75L1098.14 446.865L1103.03 446.372L1108.27 446.036L1117.06 445.722L1129.77 445.402L1137.75 445.946L1140 446.188L1144.73 446.699L1149.72 447.433L1157.93 448.869L1164.83 450.418L1172.77 452.582L1180.31 455.031L1189.54 458.599L1197.82 462.087L1200.5 463.196L1207.66 466.262L1212.52 468.591L1215.14 470.037L1217.9 471.824L1220.24 473.58L1222.69 475.661L1224.98 477.85L1227.3 480.392L1229.01 482.58L1231.22 485.874L1232.74 488.483L1234.17 491.435L1235.26 494.481L1236.15 497.879L1236.84 501.605L1237.12 504.492L1237.14 507.378L1236.87 510.551L1236.35 513.999L1235.76 516.256L1234.84 518.745L1223.85 543.408"
          stroke="#FD6A6A"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M803.906 514.043L802.344 507.462"
          stroke="#FD6A6A"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M801.471 503.786L801.718 504.825L802.308 507.307H802.307L802.344 507.462"
          stroke="#FD6A6A"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M810.74 509.903L812.37 516.504"
          stroke="#FD6A6A"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M1230.07 546.338L1233.53 538.651L1239.23 525.539L1242.57 517.19L1243.55 511.955L1243.98 505.268L1243.12 498.478L1241.37 491.405L1239.42 486.816L1236.59 481.873L1231.89 475.852L1226.73 470.937L1221.67 467.076L1215.38 463.309L1208.05 460.044L1197.89 455.629L1183.59 449.877L1182.66 449.434L1174.65 446.759L1167.43 444.691L1159.82 443.02L1158.42 442.863L1154.99 442.271L1149.5 441.372L1142.89 440.551L1140.03 440.297L1135.9 439.926L1130.66 439.602L1125.04 439.438L1116.27 439.463L1111.71 439.703L1108.55 439.637L1099.46 439.861L1084.57 442.056L1072.72 446.238L1070.31 447.401L1067.21 448.736L1063.67 449.991L1057.82 451.983L1053.39 453.732L1046.57 456.727L1038.99 460.347L1034.88 462.555L1030.65 465.208L1021.15 471.175L1011.08 479.327L1003.44 486.918L987.324 503.047L981.405 508.911L963.118 527.033L955.313 534.808L936.977 553.066L936.371 553.676L935.617 554.227L934.154 554.811L932.584 555.214L930.462 555.53L834.434 562.741L832.686 562.774L831.01 562.662L829.397 562.498L828.113 562.279L827.064 562.003L826.203 561.601L825.623 561.17L824.911 560.341L823.897 558.803L823.1 557.268L821.278 552.457L813.022 519.149L812.406 516.657L812.369 516.504"
          stroke="#FD6A6A"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M810.74 509.903L810.705 509.761L810.088 507.261L808.875 502.368"
          stroke="#FD6A6A"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M1292.79 426.111L1283.65 418.093L1279.95 415.04L1265.87 406.124L1256.01 400.628L1249.31 397.148L1243.62 394.347L1238.64 392.018L1234.73 390.417L1231.52 389.258L1229.5 388.574L1227.32 387.875L1217.32 384.35L1214.35 383.464L1209.28 382.298L1204.74 381.284L1205.69 381.154L1209.54 381.015L1212 381.119L1214.08 381.359L1216.1 381.692L1219.46 382.481L1225.44 384.287L1234.55 387.526L1242.68 390.821L1249.65 394.045L1256.07 397.392L1268.45 406.969L1277.06 412.446L1283.27 416.847L1293.28 425.539"
          stroke="#FFF38A"
          stroke-width="0.1"
        />
        <path
          d="M1289.65 429.709L1289.11 429.15L1277.44 418.465L1272.97 414.963L1265.03 409.715L1254.57 404.251L1246.17 399.787L1239.49 396.716L1235.57 395.044L1232.29 393.655L1228.84 392.402L1224.75 391.059L1221 390.067L1220.43 389.933L1214.31 386.887L1210.25 385.354L1210.14 385.336L1207.3 384.572L1203.28 383.797L1200.05 383.268L1195.43 382.739L1194.56 381.438L1183.27 381.61L1176.48 381.412L1170.61 381.393L1166.83 381.549L1161.9 383.047L1158.67 384.155L1155.2 385.563L1151.25 387.442L1147.13 389.649L1143.72 391.692L1140.34 393.996L1134.26 398.119L1128.16 402.509L1125.69 404.129L1123.63 405.218L1121.44 406.139L1119.16 406.893L1117.8 407.17L1116.05 407.329L1113.93 407.309L1111.15 407.037L1108.4 406.505L1106.42 405.911L1105.19 405.369L1103.47 404.355L1086.88 392.177L1085.52 391.263L1084.61 390.837L1083.95 390.63L1083.24 390.524L1082.9 390.522L1082.56 390.566L1082.23 390.642L1081.57 390.875L1076.25 393.338L1070.01 399.779L1067.24 401.044L1062.63 403.453L1061.42 404.229L1051.86 410.342L1050.3 411.343L1045.92 414.22L1043.41 416.087L1039.93 419.054L1027.84 425.332L985.4 457.66L981.405 460.706L975.54 465.179L963.543 474.312L955.666 480.331L936.685 491.875L928.746 496.401L924.888 498.443L913.845 503.205L907.913 505.565L889.385 512.376L879.829 515.357L860.723 520.269L855.178 521.286L851.927 521.688L849.14 521.861L843.061 521.985L836.971 521.803L834.152 521.554L830.239 521.026L823.271 519.672L812.369 516.503"
          stroke="#FFF38A"
          stroke-width="0.1"
        />
        <path
          d="M1516.25 650.444L1499.93 636.093L1498 637.871L1477.8 621.409L1474.93 618.917L1470.16 614.184L1465.45 609.509L1461.4 605.49L1460.29 604.635L1459.88 604.355L1458.69 603.69L1457.46 603.379L1456.3 603.188L1345.65 492.76L1346.6 491.719L1347.21 490.744L1347.29 489.687L1289.65 429.71"
          stroke="#22DB4B"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M1293.28 425.538L1309.63 439.726L1338.88 468.704L1365.76 495.457L1416.36 545.787L1454.15 583.262L1474.57 603.539L1479.08 608.006L1495.11 627.056L1483.68 616.932L1478.13 611.454L1476.7 610.052L1471.74 605.173V605.172L1462.38 595.961L1354.38 488.643L1327.52 460.022L1295.72 428.689L1292.79 426.11"
          stroke="#22DB4B"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1521_20473">
        <rect width="1438" height="679" fill="white" transform="translate(222 206)" />
      </clipPath>
      <clipPath id="clip1_1521_20473">
        <rect width="1437.51" height="678.503" fill="white" transform="translate(222 206)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * レース動画再生画面: GPS詳細 サーキットマップ: Suzuka
 */
export default defineComponent({
  name: 'CircuitMapImageSuzuka',
})
</script>
